import React, { useEffect, useRef, useState } from "react";
import {
  ComboboxItem,
  Divider,
  Flex,
  Group,
  Modal,
  OptionsFilter,
  Select,
  ScrollArea,
  Textarea,
  Alert,
  FileInput,
  LoadingOverlay,
  CopyButton,
  Slider,
  Radio,
  Menu,
  Container,
  Paper,
  Title,
  Tooltip,
  ActionIcon,
} from "@mantine/core";
import {
  TextInput,
  Table,
  Loader,
  Center,
  Notification,
  Button,
  NumberInput,
  Checkbox,
} from "@mantine/core";
import "./Invoice.css";
import {
  fetchLatestInvoice,
  fetchUpdateInvoiceStatus,
  getAllDuplicate,
  getAllInstructorDetails,
  getAllInstructorsDetail,
} from "../api/dynamodb-db-api";
import { useLocalStorage } from "@mantine/hooks"; // Adjust according to where your hook is located
import { User } from "../common/models";
import { Text } from "@mantine/core"; // Make sure this import is present
import { notifications, showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  FaEye,
  FaPlus,
  FaRedo,
  FaSync,
  FaFileCsv,
  FaFilter,
} from "react-icons/fa";
import { cloneDeep } from "lodash";
import jsPDF from "jspdf";
import { ApiService } from "../api/api-service";
import { log } from "console";
import { DatePicker, DatePickerInput } from "@mantine/dates";
import { saveAs } from "file-saver";
import { useMemo } from "react";
import { IconDotsVertical } from "@tabler/icons-react";
import Remark from "./remarks";
import { ChevronDown, ChevronUp } from "lucide-react";
import UpdateHoursButton from "./UpdateHoursButton";

interface StudentDetail {
  name: string;
  numOfClasses: string;
}

interface InvoiceData {
  inv_no: string; // Primary key
  bank_ifsc?: string;
  date?: string;
  issueDate?: string;
  trainerName?: string;
  courseName?: string;
  batchNumber1?: number;
  batchNumber2?: number;
  batchNumber3?: number;
  numberOfStudents?: number;
  studentMap?: Map<string, number>;
  studentNames?: string[];
  numOfClasses?: string[];
  studentDetails?: StudentDetail[];
  leaves?: number;
  classes?: number;
  prorata?: boolean;
  numClassesAsMOU?: number;
  costAsPerMOU?: number;
  trainerAskedPayment?: number;
  tds?: number;
  netPayable?: number;
  paymentPercentage?: number;
  paymentType?: string;
  instructor_bank_account?: string;
  instructor_contact?: string;
  instructor_email?: string;
  instructor_pan?: string;
  instructor_upi_id?: string;
  leavesAmountDeducted?: number;
  status?: string;
  Email?: string;
  Contact?: string;
  mouHours?: string;
  tdsStatus?: string;
  approvedBy?: string;
  // Add the missing fields

  email?: string;
  name?: string;
  contact?: string;

  customCalculation?: boolean; // For Custom Calculation Checkbox
  tdsAmount?: number;
  remark?: string;
  internalDescription?: string; // Internal team notes, never shown to trainers

  dateOfAssign: string;

  mouAmount: number;
  trainerLeaves: number;
  attendedHours: string;
}
interface Instructor {
  email: string;
  name: string;
  contact: string;
  sno?: number;
  tags?: string[];
  instructor_upi_id?: string;
  instructor_pan?: string;
  instructor_bank_account?: string;
  dateOfAssign: string;
  mouHours: string;
  mouAmount: number;
  trainerLeaves: number;
  attendedHours: string;
}

interface Student {
  name: string;
  numOfClasses: string;
  amount?: number;
  email?: string;
  received?: number;
  balance?: number;
  referral?: number;
  currency: string;
  paymentStatus: string;
  comment: string;
  studentClasses: string;
}

interface InstructorAllDetails {
  email: string;
  name: string;
  contact: string;
  sno?: number;
  tags?: string[];
  instructor_upi_id?: string;
  instructor_pan?: string;
  instructor_bank_account?: string;
  dateOfAssign: string;
  mouHours: string;
  mouAmount: number;
  trainerLeaves: number;
  attendedHours: string;
}
interface InstructorDetails {
  dateOfAssign: string;
  mouHours: string;
  mouAmount: number;
  trainerLeaves: number;
  attendedHours: string;
}

interface Batch {
  batch_no: string;
  courseName: string;
  trainerName: string;
  oldTrainerName1?: string;
  oldTrainerName2?: string;
  admin: string;
  students: Student[];
  MouStatus: string;
  batchStatus: string;
  numSessions?: number;
  startDate?: string;
  scheduleStatus?: string;
  scheduleDetails?: string;
  comments?: string;
  email?: string;
  linkedBatches?: string[];
  instructors: InstructorDetails[];
  instructor: Instructor[];
}
const InvoicePage: React.FC = () => {
  const [tableData, setTableData] = useState<InvoiceData[]>([]);
  const [filteredData, setFilteredData] = useState<InvoiceData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Unified search filter for Trainer Name, Batch Number, and Invoice Number
  const [searchFilter, setSearchFilter] = useState<string>("");

  // Split filter fields (kept for UI & to compose unified searchFilter used by the existing filtering logic)
  const [trainerFilter, setTrainerFilter] = useState<string>("");
  const [batchFilter, setBatchFilter] = useState<string>("");
  const [invoiceFilter, setInvoiceFilter] = useState<string>("");

  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [startDateFilter, setStartDateFilter] = useState<string | null>(null);
  const [endDateFilter, setEndDateFilter] = useState<string | null>(null);

  const [currentPage, setCurrentPage] = useState(1); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(15); // Rows per page

  // Calculate the range of rows for the current page
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  // this is define for highlight the complete data in Table code
  const [allRows, setAllRows] = useState<InvoiceData[]>([]);
  const indexOfLastRoww = currentPage * rowsPerPage;
  const indexOfFirstRoww = indexOfLastRow - rowsPerPage;
  const currentRowss = allRows.slice(indexOfFirstRoww, indexOfLastRoww);
  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const [openCards, setOpenCards] = useState<Record<string, boolean>>({});

  // const [screenshotCache, setScreenshotCache] = useState<Record<string, string[]>>({});

  const [showForm, setShowForm] = useState<boolean>(false);

  const [formData, setFormData] = useState<InvoiceData>({
    inv_no: "",
    date: "",
    trainerName: "",
    courseName: "",
    batchNumber1: 0,
    batchNumber2: 0,
    batchNumber3: 0,
    numberOfStudents: 0,
    leaves: 0,
    classes: 0,
    prorata: false,
    numClassesAsMOU: 0,
    costAsPerMOU: 0,
    trainerAskedPayment: 0,
    tds: 0,
    netPayable: 0,
    status: "Open",
    studentMap: new Map(),
    studentNames: [],
    numOfClasses: [],
    studentDetails: [],
    paymentPercentage: 0,
    paymentType: "",
    instructor_bank_account: "",
    instructor_contact: "",
    instructor_email: "",
    instructor_pan: "",
    instructor_upi_id: "",
    leavesAmountDeducted: 0,
    mouHours: "",
    tdsStatus: "No",
    approvedBy: "",
    email: "",
    name: "",
    contact: "",
    remark: "",
    internalDescription: "",
    dateOfAssign: "",
    mouAmount: 0,
    trainerLeaves: 0,
    attendedHours: "",
  });

  const [selectedInvoice, setSelectedInvoice] = useState<InvoiceData | null>(
    null,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDuplicateModalOpen, setIsDuplicateModalOpen] = useState(false);

  const [invoices, setInvoices] = useState<InvoiceData[]>([]);

  // List of invoices
  // const [duplicates, setDuplicates] = useState<{ batchNumber: string; ids: string[] }[]>([]);
  // const [duplicates, setDuplicates] = useState<{ batchNumber: string; ids: string[] }[]>([]);
  const [duplicates, setDuplicates] = useState<any[]>([]);
  const [duplicatess, setDuplicatess] = useState<any[]>([]);

  const [instructors, setInstructors] = useState<ComboboxItem[]>([]);
  const instructorsRef = useRef<Instructor[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [opened, setOpened] = useState(false);
  // State for TDS amount and checkbox status
  const [tdsStatus, setTdsStatus] = useState<string>(
    formData.tdsStatus || "No",
  );
  const [tdsAmount, setTdsAmount] = useState<number>(0);

  // State for TDS amount and checkbox status in Modal
  const [modalTdsStatus, setModalTdsStatus] = useState<string>(
    selectedInvoice?.tdsStatus || "No",
  );
  const [modalTdsAmount, setModalTdsAmount] = useState<number>(0);
  const [lastRefreshTime, setLastRefreshTime] = useState<string | null>(null);

  const [lastSno, setLastSno] = useState<number>(0);

  const [showProcessingModal, setShowProcessingModal] = useState(false);
  const [selectedInvoiceForProcessing, setSelectedInvoiceForProcessing] =
    useState<any | null>(null);

  // Payment Sent Modal
  const [showPaymentSentModal, setShowPaymentSentModal] = useState(false);
  const [selectedInvoiceForPaymentSent, setSelectedInvoiceForPaymentSent] =
    useState<any | null>(null);
  const [selectedFile, setSelectedFile] = useState<File[]>([]);

  const [screenshotUrl, setScreenshotUrl] = useState<string[]>([]); // To store the array of image URLs
  const [screenshotLoading, setScreenshotLoading] = useState(false); // Loading state for screenshot
  const [screenshotError, setScreenshotError] = useState<string | null>(null); // Error state for screenshot
  const [screenshotCache, setScreenshotCache] = useState<
    Record<string, string[]>
  >({}); // Cache for screenshots
  const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null);

  // for delete payment screenshot
  const [showConfirm, setShowConfirm] = useState(false); // For confirmation dialog

  const [imageToDelete, setImageToDelete] = useState<string | null>(null);

  // for loading in upload screenshot
  const [isUploading, setIsUploading] = useState(false);

  // for screenshot preview Feature
  const [filePreviews, setFilePreviews] = useState<string[]>([]);

  const [user] = useLocalStorage<User | undefined>({ key: "user" });

  const [previewImage, setPreviewImage] = useState<string | null>(null); // To handle image preview modal

  // checkbox for remittane
  const [sendWithRemittance, setSendWithRemittance] = useState(false);
  const [issueDate, setIssueDate] = useState<string>("");

  const [allBatches, setAllBatches] = useState<Batch[]>([]);
  const [batchOptions, setBatchOptions] = useState<string[]>([]);
  const [primaryBatchNo, setPrimaryBatchNo] = useState<string | null>(null);
  const [batchNo2, setBatchNo2] = useState<string | null>(null);
  const [batchNo3, setBatchNo3] = useState<string | null>(null);

  const handleRemarkChange = (newRemark: string) => {
    setSelectedInvoice((prev) =>
      prev ? { ...prev, remark: newRemark } : null,
    );
  };

  const toggleCard = (inv_no: string) => {
    setOpenCards((prev) => ({ ...prev, [inv_no]: !prev[inv_no] }));
  };
  useEffect(() => {
    const fetchBatches = async () => {
      try {
        const response = await ApiService.getInstance().get("/batches");
        const data = response.data.data.map((batch: Batch) => ({
          ...batch,
          linkedBatches: batch.linkedBatches || [],
        }));

        setAllBatches(data);
        setBatchOptions(data.map((b: { batch_no: any }) => b.batch_no));
      } catch (error) {
        console.error("Failed to fetch batches:", error);
      }
    };

    fetchBatches();
  }, []);

  // Modified useEffect to correctly set batch numbers when an invoice is selected
  useEffect(() => {
    // When selectedInvoice changes (when a user clicks on an invoice in the table)
    if (selectedInvoice) {
      // Set the primary batch number from the selected invoice
      setPrimaryBatchNo(
        selectedInvoice.batchNumber1
          ? selectedInvoice.batchNumber1.toString()
          : null,
      );

      // Find the batch details for the primary batch to get linked batches
      const selectedBatch = allBatches.find(
        (b) => b.batch_no === String(selectedInvoice.batchNumber1),
      );

      // If we found the batch and it has linked batches, set batch 2 and 3 accordingly
      if (selectedBatch?.linkedBatches?.length) {
        const [linked1, linked2] = selectedBatch.linkedBatches;

        // Set batch number 2 and 3 in state for display
        setBatchNo2(linked1 || "");
        setBatchNo3(linked2 || "");
      } else {
        // If no linked batches, set them to empty or the values from the invoice if they exist
        setBatchNo2(
          selectedInvoice.batchNumber2 && selectedInvoice.batchNumber2 !== 0
            ? selectedInvoice.batchNumber2.toString()
            : "",
        );
        setBatchNo3(
          selectedInvoice.batchNumber3 && selectedInvoice.batchNumber3 !== 0
            ? selectedInvoice.batchNumber3.toString()
            : "",
        );
      }
    }
  }, [selectedInvoice, allBatches]);

  const generatePDF = (data: any) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Add logo centered and at the top
    const logoWidth = 35;
    const logoHeight = 10;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 20;

    doc.addImage(
      "https://ik.imagekit.io/2fljt9khj/logo%20L%20remove%20bg%20thinkcloudly.png?updatedAt=1719406869813",
      "PNG",
      logoX,
      logoY,
      logoWidth,
      logoHeight,
    );

    // Set document font and size
    doc.setFontSize(12);
    doc.setFont("Helvetica", "bold");

    // Invoice Title
    doc.text("Remittance Advice", pageWidth / 2, logoY + logoHeight + 10, {
      align: "center",
    });

    // Invoice details
    doc.text(`Issue Date: ${data.issueDate}`, 8, logoY + logoHeight + 20);
    doc.text(`Trainer Name: ${data.trainerName}`, 8, logoY + logoHeight + 30);
    doc.text(
      `Trainer Contact: ${data.trainerContact}`,
      8,
      logoY + logoHeight + 40,
    );

    // Batch and Student Details Table
    (doc as any).autoTable({
      startY: logoY + logoHeight + 60,
      head: [
        [
          "Date",
          "Group Number",
          "No. of Students",
          "No. of Classes",
          "Total Leaves",
          "Amount",
        ],
      ],
      body: [
        [
          data.columnDate || "NA",
          data.groupNumber || "NA",
          data.numberOfStudents.toString() || "0",
          Array.isArray(data.classes)
            ? data.classes.join(", ")
            : data.classes || "NA",
          data.leaves.toString() || "0",
          data.trainerAmount || "NA",
        ],
      ],
      theme: "plain",
      styles: {
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
    });

    // Payment Details Table
    const finalY = (doc as any).lastAutoTable
      ? (doc as any).lastAutoTable.finalY + 10
      : logoY + logoHeight + 70;

    doc.setFontSize(12);
    doc.text("Final Payment After Deductions:", 8, finalY);

    (doc as any).autoTable({
      startY: finalY + 10,
      head: [
        [
          "No. of Extra Leaves",
          "Leave Amount Deducted",
          "TDS 10% Deducted",
          "Net Amount Paid",
        ],
      ],
      body: [
        [
          data.extraLeaves || "NA",
          data.leaveAmountDeducted || "NA",
          data.tdsDeducted || "NA",
          data.netAmountPaid || "NA",
        ],
      ],
      theme: "plain",
      styles: {
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255],
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
    });
    // Additional contact and footer details
    const contactY = (doc as any).lastAutoTable
      ? (doc as any).lastAutoTable.finalY + 20
      : finalY + 40;
    doc.setFontSize(10);
    doc.text(
      "For any payment-related queries, please contact: mukesh.kumar@thinkcloudly.com",
      8,
      contactY,
    );
    doc.text(
      "Thank you for your services. We appreciate your partnership.",
      8,
      contactY + 10,
    );
    doc.text("By:", 8, contactY + 20);
    doc.text("Namrata Arora", 8, contactY + 30);
    doc.text(
      "This is a computerized document and does not require a physical signature.",
      8,
      contactY + 40,
    );
    // Additional Footer Details
    const footerY = pageHeight - 20;
    doc.setFontSize(8);
    doc.text(
      "1111-21 Iceboat Terr, Toronto, Ontario M5V 4A9",
      pageWidth / 2,
      footerY,
      { align: "center" },
    );
    doc.text(
      "+1 (725) 710-9949   info@thinkcloudly.com   www.thinkcloudly.com",
      pageWidth / 2,
      footerY + 10,
      { align: "center" },
    );

    // Return base64 encoded PDF data
    const pdfDataUri = doc.output("datauristring");
    const base64Pdf = pdfDataUri.split(",")[1];
    return base64Pdf;
  };

  const generateRemittancePDF = () => {
    if (!selectedInvoiceForPaymentSent) {
      console.error("No invoice selected for PDF generation.");
      return null;
    }

    const {
      date,
      trainerName,
      courseName,
      batchNumber1,
      batchNumber2,
      batchNumber3,
      numberOfStudents,
      leaves,
      classes,
      trainerAskedPayment,
      tds,
      netPayable,
      instructor_contact,
      instructor_email,
      approvedBy,
      leavesAmountDeducted,
      tdsStatus,
      tdsAmount,
    } = selectedInvoiceForPaymentSent; // Yeh important hai! Ab hum sahi object use kar rahe hain

    //  Issue Date (User-selected Date Picker)
    const formattedIssueDate = issueDate
      ? new Date(issueDate).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      : "NA";

    //  Date Column (From Invoice)
    const formattedColumnDate = date
      ? new Date(date).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      : "NA";

    //  Combine Batch Numbers Properly
    const batchNumbers = [batchNumber1, batchNumber2, batchNumber3].filter(
      (batch) => batch && String(batch) !== "0",
    );

    const groupNumber = batchNumbers.length
      ? `${courseName} - ${batchNumbers.join(", ")}`
      : courseName || "NA";

    //  Calculate Extra Leaves
    const leaveAmount = parseInt(String(leaves)) || 0;
    const extraLeaves = leaveAmount > 3 ? leaveAmount - 3 : 0;

    //  Ensure Fields Have Default Values
    const data = {
      issueDate: formattedIssueDate || "NA",
      trainerName: trainerName || "NA",
      trainerContact: instructor_contact || "NA",
      trainerEmail: instructor_email || "NA",
      courseName: courseName || "NA",
      groupNumber: groupNumber,
      numberOfStudents: numberOfStudents || "0",
      classes: classes || "0",
      leaves: leaves || "0",
      extraLeaves: extraLeaves > 0 ? extraLeaves.toString() : "NA",
      leaveAmountDeducted: leavesAmountDeducted
        ? `${leavesAmountDeducted}/-`
        : "NA",
      tdsDeducted: tds ? `${tds}/-` : "NA",
      trainerAmount: trainerAskedPayment ? `${trainerAskedPayment}/-` : "NA",
      netAmountPaid: netPayable ? `${netPayable}/-` : "NA",
      tdsStatus: tdsStatus || "NA",
      approvedBy: approvedBy || "NA",
      columnDate: formattedColumnDate,
    };
    return generatePDF(data);
  };

  const SendEmail = async () => {
    try {
      // Generate base64 PDF data
      const pdfBase64 = generateRemittancePDF();
      const { email } = formData;

      // Send email with PDF attachment
      const response = await ApiService.getInstance().post(
        `/bucket`,
        {
          ...formData,
          email: formData.email,
          pdfData: pdfBase64,
          name: formData.name,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      alert(`Email sent successfully to ${formData.email}`);
    } catch (error) {
      alert(`Error sending email to ${formData.email}`);
    }
  };

  const handleStudentDetailChange = (
    index: number,
    field: keyof StudentDetail,
    value: string,
  ) => {
    setSelectedInvoice((prev) => {
      if (!prev) return null;
      const updatedDetails = [...(prev.studentDetails || [])];
      updatedDetails[index] = { ...updatedDetails[index], [field]: value };
      return { ...prev, studentDetails: updatedDetails };
    });
  };
  const addStudentField = () => {
    setSelectedInvoice((prev) => {
      if (!prev) return null;
      return {
        ...prev,
        studentDetails: [
          ...(prev.studentDetails || []),
          { name: "", numOfClasses: "" },
        ],
      };
    });
  };

  const removeStudentField = (index: number) => {
    setSelectedInvoice((prev) => {
      if (!prev) return null;
      const updatedDetails = (prev.studentDetails || []).filter(
        (_, i) => i !== index,
      );
      return { ...prev, studentDetails: updatedDetails };
    });
  };

  const handlePreviewScreenshot = (url: string) => {
    setPreviewImage(url); // Open the preview modal with the selected image
  };
  const openConfirmDelete = (url: string) => {
    setSelectedImageUrl(url); // Set the screenshot to delete
    setShowConfirm(true); // Open the confirmation dialog
  };

  const handleDeleteScreenshot = async (url: string) => {
    setShowConfirm(true);
    setImageToDelete(url);
    setSelectedImageUrl(url);
  };

  const cancelDeleteScreenshot = () => {
    setShowConfirm(false);
    setImageToDelete(null);
  };

  const handleRefresh = () => {
    const currentTime = new Date().toLocaleString(); // Get the current date and time in a readable format
    setLastRefreshTime(currentTime); // Update the state with the current time
    // Add your refresh logic here
    fetchInvoices(); // Fetch latest data
  };

  useEffect(() => {
    setAllRows(filteredData); // Keep allRows synced with filteredData
  }, [filteredData]);

  const form = useForm({
    initialValues: {
      name: "",
      email: "",
      sno: 0,
      contact: "",
      tags: "",
      instructor_upi_id: "",
      instructor_pan: "",
      instructor_bank_account: "",
    },
  });
  // Fetch last SNO from the backend on component mount
  useEffect(() => {
    const fetchLastSno = async () => {
      try {
        const response = await ApiService.getInstance().get(
          "/tc-invoice-details-trainers/next-sno",
        );

        if (response && (response.status === 200 || response.status === 201)) {
          const nextSno = response.data?.data; // backend sends { data: number }

          setLastSno(nextSno);
          form.setFieldValue("sno", nextSno); // directly set since backend already gives incremented sno
        } else {
          notifications.show({
            title: "Failed to fetch",
            message: "Could not fetch the next SNO.",
            color: "red",
            position: "bottom-right",
          });
        }
      } catch (error) {
        console.error("Error fetching next SNO:", error);
        alert("An error occurred while fetching the next SNO.");
      }
    };

    fetchLastSno();
  }, []);

  useEffect(() => {
    const fetchScreenshots = async (inv_no: string) => {
      setScreenshotLoading(true); // Start loading for screenshots
      setScreenshotError(null); // Clear previous errors

      try {
        const response = await ApiService.getInstance().post(
          "/bucket/get-images",
          { inv_no },
        );

        const imageUrls = response.data?.imageUrls || []; // Get the array of image URLs
        setScreenshotCache((prevCache) => ({
          ...prevCache,
          [inv_no]: imageUrls,
        })); // Cache the result
        setScreenshotUrl(imageUrls); // Set the array of image URLs for the current modal
      } catch (err) {
        console.error("Error fetching screenshots:", err);
        setScreenshotCache((prevCache) => ({ ...prevCache, [inv_no]: [] })); // Cache the error as an empty array
        setScreenshotUrl([]); // Reset screenshot URLs
        setScreenshotError(null); // Set error message
      } finally {
        setScreenshotLoading(false); // Stop loading for screenshots
      }
    };

    if (selectedInvoice?.inv_no) {
      const cachedUrls = screenshotCache[selectedInvoice.inv_no];

      if (cachedUrls && cachedUrls.length > 0) {
        // Pehle cached screenshots show karo
        setScreenshotUrl(cachedUrls);
      } else {
        // Phir API se fetch karo
        fetchScreenshots(selectedInvoice.inv_no);
      }
    }
  }, [selectedInvoice]);

  // Delete Payment Sent Screen shot

  const confirmDeleteScreenshot = async () => {
    if (!selectedInvoice?.inv_no || !selectedImageUrl) {
      console.error("Invoice number or image URL is missing.");
      return;
    }

    try {
      const response = await ApiService.getInstance().delete(
        "/bucket/delete-image",
        {
          data: {
            inv_no: selectedInvoice.inv_no,
            image_url: selectedImageUrl, // Pass the specific image URL to delete
          },
        },
      );

      if (response.data.message) {
        // **Deleted Screenshot ko state se remove karna**
        const updatedScreenshots = screenshotUrl.filter(
          (url) => url !== selectedImageUrl,
        );

        setScreenshotUrl(updatedScreenshots); // Update the list of screenshots
        setScreenshotCache((prevCache) => ({
          ...prevCache,
          [selectedInvoice.inv_no]: updatedScreenshots,
        }));

        setShowConfirm(false); // Close confirmation dialog
        showNotification({
          title: "Success",
          message: "Screenshot deleted successfully.",
          color: "green",
        });
      }
    } catch (error) {
      console.error("Failed to delete screenshot:", error);
      showNotification({
        title: "Error",
        message: "Failed to delete screenshot. Please try again.",
        color: "red",
      });
    }
  };

  // Preview Delete screenshot
  const handleRemovePreview = (index: number) => {
    const updatedFiles = selectedFile.filter((_, i) => i !== index);
    const updatedPreviews = filePreviews.filter((_, i) => i !== index);
    setSelectedFile(updatedFiles);
    setFilePreviews(updatedPreviews);
  };

  // Function to handle form submission
  const handleCreateInstructor = async (values: typeof form.values) => {
    setLoading(true);
    const token = localStorage.getItem("token");

    try {
      const response = await ApiService.getInstance().post(
        "/tc-invoice-details-trainers/instructors",
        values,
      );

      if (response.status === 200 || response.status === 201) {
        alert("Instructor added successfully!");
        setOpened(false);
        form.reset(); // Reset the form after successful submission
      } else {
        alert(
          `Failed to add instructor: ${response.data?.error || "Unknown error"}`,
        );
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  // Add this with your other state declarations

  const [filteredInstructors, setFilteredInstructors] = useState<Instructor[]>(
    [],
  );

  // useEffect to fetch instructors on component mount
  useEffect(() => {
    fetchInstructors();
  }, []);

  // Fetch instructor details from backend
  const fetchInstructors = async () => {
    try {
      const response = await getAllInstructorDetails("instructors");
      instructorsRef.current = response;
      // Initially show all instructor emails in dropdown
      const instructorOptions: ComboboxItem[] = response.map(
        (instructor: Instructor) => ({
          label: instructor.email || "",
          value: instructor.email || "",
        }),
      );
      setInstructors(instructorOptions);
    } catch (error) {
      console.error("Error fetching instructors:", error);
    }
  };

  // Enhanced filterInstructorsByBatch function
  const filterInstructorsByBatch = (selectedBatchNo: string | null) => {
    if (!selectedBatchNo) {
      // Reset to show all instructors if no batch is selected
      const allInstructorOptions = instructorsRef.current.map((instructor) => ({
        label: instructor.email || "",
        value: instructor.email || "",
      }));
      setInstructors(allInstructorOptions);
      setFilteredInstructors([]);
      return;
    }

    const selectedBatch = allBatches.find(
      (batch) => batch.batch_no === selectedBatchNo,
    );

    if (
      selectedBatch &&
      selectedBatch.instructor &&
      selectedBatch.instructor.length > 0
    ) {
      // Get all unique instructor emails from the batch
      const batchInstructorEmails = selectedBatch.instructor
        .map((inst) => inst.email)
        .filter(
          (email): email is string => Boolean(email) && email.trim() !== "",
        );
      // Filter the main instructors list to only include those in the batch
      const batchInstructors = instructorsRef.current.filter(
        (instructor) =>
          instructor.email && batchInstructorEmails.includes(instructor.email),
      );
      setFilteredInstructors(batchInstructors);

      // Create dropdown options showing only emails of instructors in this batch
      const instructorOptions = batchInstructors.map((instructor) => ({
        label: instructor.email || "",
        value: instructor.email || "",
      }));
      setInstructors(instructorOptions);

      if (batchInstructors.length > 1) {
        console.log(
          `Found ${batchInstructors.length} instructors for this batch. Please select one.`,
        );
      } else if (batchInstructors.length === 1) {
        console.log(
          `Found 1 instructor for this batch: ${batchInstructors[0].email}`,
        );
      }
    } else {
      console.log("No instructors found for this batch");
      setFilteredInstructors([]);
      setInstructors([]);
    }
  };

  const resetInstructorFiltering = () => {
    // Reset to show all instructors
    const allInstructorOptions = instructorsRef.current.map((instructor) => ({
      label: instructor.email || "",
      value: instructor.email || "",
    }));

    setInstructors(allInstructorOptions);
    setFilteredInstructors([]);
  };
  // Updated handleChangeCommon function - Remove UPI, Bank, PAN auto-population
  const handleChangeCommon = (key: string, value: string | null) => {
    const newFormData = { ...formData, [key]: value };

    // Auto-populate instructor details when email changes
    if (key === "instructor_email") {
      // Use filtered instructors if available, otherwise use all instructors
      const instructorsToSearch =
        filteredInstructors.length > 0
          ? filteredInstructors
          : instructorsRef.current;

      // Find the instructor in the general instructors list for basic details
      const selectedInstructor = instructorsToSearch.find(
        (instructor) => instructor.email === value,
      );

      if (selectedInstructor) {
        // Populate ONLY basic instructor fields (removed UPI, PAN, Bank details)
        newFormData.trainerName = selectedInstructor.name || "";
        newFormData.instructor_contact = selectedInstructor.contact || "";

        // If we have a selected batch, get batch-specific instructor details
        if (formData.batchNumber1) {
          const selectedBatch = allBatches.find(
            (batch) => batch.batch_no === formData.batchNumber1?.toString(),
          );

          if (selectedBatch && selectedBatch.instructor) {
            // Find the specific instructor entry in this batch
            const batchInstructorEntry = selectedBatch.instructor.find(
              (batchInst) => batchInst.email === value,
            );

            if (batchInstructorEntry) {
              // Map batch instructor data to invoice fields
              newFormData.dateOfAssign =
                batchInstructorEntry.dateOfAssign || "";
              newFormData.mouHours = batchInstructorEntry.mouHours || "";
              newFormData.mouAmount = batchInstructorEntry.mouAmount || 0;
              newFormData.trainerLeaves =
                batchInstructorEntry.trainerLeaves || 0;
              newFormData.attendedHours =
                batchInstructorEntry.attendedHours || "";

              // Auto-populate invoice-specific fields based on batch instructor data
              newFormData.classes =
                parseFloat(batchInstructorEntry.attendedHours || "0") || 0; // Number of Classes = Attended Hours
              newFormData.numClassesAsMOU =
                parseFloat(batchInstructorEntry.mouHours || "0") || 0; // Classes As Per MOU = MOU Hours
              newFormData.costAsPerMOU = batchInstructorEntry.mouAmount || 0; // MOU Amount (Per Student) = MOU Amount
              // newFormData.trainerAskedPayment = batchInstructorEntry.mouAmount || 0; // Trainer Amount = MOU Amount
              newFormData.leaves = batchInstructorEntry.trainerLeaves || 0; // Leaves = Trainer Leaves
            }
          }
        }
      } else {
        // Clear all fields if no match is found (removed UPI, PAN, Bank clearing)
        newFormData.trainerName = "";
        newFormData.instructor_contact = "";
        newFormData.dateOfAssign = "";
        newFormData.mouHours = "";
        newFormData.mouAmount = 0;
        newFormData.trainerLeaves = 0;
        newFormData.attendedHours = "";
        newFormData.classes = 0;
        newFormData.numClassesAsMOU = 0;
        newFormData.costAsPerMOU = 0;
        newFormData.trainerAskedPayment = 0;
        newFormData.leaves = 0;
      }
    }

    setFormData(newFormData);
  };

  const handleModalBatchSelection = (val: string | null) => {
    if (!val || !selectedInvoice) {
      console.log(
        " No value provided or no selectedInvoice, keeping current selection",
      );
      return;
    }

    const selectedBatch = allBatches.find((b) => b.batch_no === val);
    if (!selectedBatch) {
      console.log(" Batch not found in allBatches array");
      return;
    }
    // Filter instructors based on selected batch
    filterInstructorsByBatch(val);

    const updatedInvoice = {
      ...selectedInvoice,
      // Clear instructor fields first to avoid stale data (removed UPI, PAN, Bank)
      instructor_email: "",
      trainerName: "",
      instructor_contact: "",
      dateOfAssign: "",
      mouHours: "",
      mouAmount: 0,
      trainerLeaves: 0,
      attendedHours: "",
      classes: 0,
      numClassesAsMOU: 0,
      costAsPerMOU: 0,
      trainerAskedPayment: 0,
      leaves: 0,

      // Batch numbers - ENSURE PROPER CONVERSION
      batchNumber1: Number(selectedBatch.batch_no),
      batchNumber2: Number(selectedBatch.linkedBatches?.[0] ?? 0),
      batchNumber3: Number(selectedBatch.linkedBatches?.[1] ?? 0),

      // Basic batch info
      courseName: selectedBatch.courseName || "",

      // Student related data (REMOVED numOfClasses auto-population)
      numberOfStudents: selectedBatch.students?.length || 0,
      studentNames:
        selectedBatch.students?.map((student) => student.name) || [],
      studentDetails:
        selectedBatch.students?.map((student) => ({
          name: student.name,
          numOfClasses: student.studentClasses?.toString() || "0", // Empty string instead of auto-populated value
        })) || [],
    };

    // Only auto-populate if there's exactly ONE instructor in the batch
    if (selectedBatch.instructor?.length === 1) {
      const singleBatchInstructor = selectedBatch.instructor[0];

      // Find the full instructor details from the general list
      const fullInstructorDetails = instructorsRef.current.find(
        (inst) => inst.email === singleBatchInstructor.email,
      );

      if (fullInstructorDetails) {
        // Auto-populate ONLY basic instructor details (removed UPI, PAN, Bank)
        updatedInvoice.instructor_email = singleBatchInstructor.email || "";
        updatedInvoice.trainerName = fullInstructorDetails.name || "";
        updatedInvoice.instructor_contact = fullInstructorDetails.contact || "";

        // Auto-populate batch-specific data
        updatedInvoice.dateOfAssign = singleBatchInstructor.dateOfAssign || "";
        updatedInvoice.mouHours = singleBatchInstructor.mouHours || "";
        updatedInvoice.mouAmount = singleBatchInstructor.mouAmount || 0;
        updatedInvoice.trainerLeaves = singleBatchInstructor.trainerLeaves || 0;
        updatedInvoice.attendedHours =
          singleBatchInstructor.attendedHours || "";

        // Map to invoice fields
        updatedInvoice.classes =
          parseFloat(singleBatchInstructor.attendedHours || "0") || 0;
        updatedInvoice.numClassesAsMOU =
          parseFloat(singleBatchInstructor.mouHours || "0") || 0;
        updatedInvoice.costAsPerMOU = singleBatchInstructor.mouAmount || 0;
        // updatedInvoice.trainerAskedPayment = singleBatchInstructor.mouAmount || 0;
        updatedInvoice.leaves = singleBatchInstructor.trainerLeaves || 0;

        console.log(
          "Modal - Auto-selected single instructor:",
          singleBatchInstructor.email,
        );
      }
    } else if (selectedBatch.instructor?.length > 1) {
      console.log(
        ` Modal - Multiple instructors found (${selectedBatch.instructor.length}). Please select one manually.`,
      );
    } else {
      console.log("Modal - No instructors found for this batch");
    }

    setSelectedInvoice(updatedInvoice);
  };
const formatDecimalHoursToTime = (
  value: number | string | null | undefined
): string => {
  if (value === undefined || value === null || value === "") return "";

  const decimalHours = Number(value);
  if (isNaN(decimalHours) || decimalHours < 0) return "";

  let hours = Math.floor(decimalHours);
  let minutes = Math.round((decimalHours - hours) * 60);

  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;

  return `${hours}h ${minutes}m`;
};

  // Updated handleBatchSelection function - Remove UPI, Bank, PAN auto-population
  const handleBatchSelection = (val: string | null) => {
    if (!val) return;

    const selectedBatch = allBatches.find((b) => b.batch_no === val);
    if (selectedBatch) {
      // Filter instructors based on selected batch - THIS IS KEY
      filterInstructorsByBatch(val);

      const updatedFormData = {
        ...formData,
        // Clear instructor fields first to avoid stale data (removed UPI, PAN, Bank)
        instructor_email: "",
        trainerName: "",
        instructor_contact: "",
        dateOfAssign: "",
        mouHours: "",
        mouAmount: 0,
        trainerLeaves: 0,
        attendedHours: "",
        classes: 0,
        numClassesAsMOU: 0,
        costAsPerMOU: 0,
        trainerAskedPayment: 0,
        leaves: 0,

        // Batch numbers
        batchNumber1: Number(selectedBatch.batch_no),
        batchNumber2: Number(selectedBatch.linkedBatches?.[0] ?? 0),
        batchNumber3: Number(selectedBatch.linkedBatches?.[1] ?? 0),

        // Basic batch info
        courseName: selectedBatch.courseName || "",

        // Student related data (REMOVED numOfClasses auto-population)
        numberOfStudents: selectedBatch.students?.length || 0,
        studentNames:
          selectedBatch.students?.map((student) => student.name) || [],
        studentDetails:
          selectedBatch.students?.map((student) => ({
            name: student.name,
            numOfClasses: student.studentClasses?.toString() || "0", // Empty string instead of auto-populated value
          })) || [],
      };

      // Only auto-populate if there's exactly ONE instructor in the batch
      if (selectedBatch.instructor?.length === 1) {
        const singleBatchInstructor = selectedBatch.instructor[0];

        // Find the full instructor details from the general list
        const fullInstructorDetails = instructorsRef.current.find(
          (inst) => inst.email === singleBatchInstructor.email,
        );

        if (fullInstructorDetails) {
          // Auto-populate ONLY basic instructor details (removed UPI, PAN, Bank)
          updatedFormData.instructor_email = singleBatchInstructor.email || "";
          updatedFormData.trainerName = fullInstructorDetails.name || "";
          updatedFormData.instructor_contact =
            fullInstructorDetails.contact || "";

          // Auto-populate batch-specific data
          updatedFormData.dateOfAssign =
            singleBatchInstructor.dateOfAssign || "";
          updatedFormData.mouHours = singleBatchInstructor.mouHours || "";
          updatedFormData.mouAmount = singleBatchInstructor.mouAmount || 0;
          updatedFormData.trainerLeaves =
            singleBatchInstructor.trainerLeaves || 0;
          updatedFormData.attendedHours =
            singleBatchInstructor.attendedHours || "";

          // Map to invoice fields
          updatedFormData.classes =
            parseFloat(singleBatchInstructor.attendedHours || "0") || 0;
          updatedFormData.numClassesAsMOU =
            parseFloat(singleBatchInstructor.mouHours || "0") || 0;
          updatedFormData.costAsPerMOU = singleBatchInstructor.mouAmount || 0;
          updatedFormData.trainerAskedPayment =
            singleBatchInstructor.mouAmount || 0;
          updatedFormData.leaves = singleBatchInstructor.trainerLeaves || 0;

          console.log(
            "Form - Auto-selected single instructor:",
            singleBatchInstructor.email,
          );
        }
      } else if (selectedBatch.instructor?.length > 1) {
        console.log(
          `Form - Multiple instructors found (${selectedBatch.instructor.length}). Please select one manually.`,
        );
      }

      setFormData(updatedFormData);
    }
  };

  // Updated handleModalChange function - Remove UPI, Bank, PAN auto-population
  const handleModalChange = (key: string, value: string | null) => {
    if (!selectedInvoice) return;

    const updatedInvoice = { ...selectedInvoice, [key]: value };

    if (key === "instructor_email") {
      const instructorsToSearch =
        filteredInstructors.length > 0
          ? filteredInstructors
          : instructorsRef.current;

      const selectedInstructor = instructorsToSearch.find(
        (instructor) => instructor.email === value,
      );

      if (selectedInstructor) {
        // Populate ONLY basic instructor fields (removed UPI, PAN, Bank)
        updatedInvoice.trainerName = selectedInstructor.name || "";
        updatedInvoice.instructor_contact = selectedInstructor.contact || "";

        // If we have a selected batch, get batch-specific instructor details
        if (updatedInvoice.batchNumber1) {
          const selectedBatch = allBatches.find(
            (batch) =>
              batch.batch_no === updatedInvoice.batchNumber1?.toString(),
          );

          if (selectedBatch && selectedBatch.instructor) {
            const batchInstructorEntry = selectedBatch.instructor.find(
              (batchInst) => batchInst.email === value,
            );

            if (batchInstructorEntry) {
              updatedInvoice.dateOfAssign =
                batchInstructorEntry.dateOfAssign || "";
              updatedInvoice.mouHours = batchInstructorEntry.mouHours || "";
              updatedInvoice.mouAmount = batchInstructorEntry.mouAmount || 0;
              updatedInvoice.trainerLeaves =
                batchInstructorEntry.trainerLeaves || 0;
              updatedInvoice.attendedHours =
                batchInstructorEntry.attendedHours || "";

              // Map to invoice fields
              updatedInvoice.classes =
                parseFloat(batchInstructorEntry.attendedHours || "0") || 0;
              updatedInvoice.numClassesAsMOU =
                parseFloat(batchInstructorEntry.mouHours || "0") || 0;
              updatedInvoice.costAsPerMOU = batchInstructorEntry.mouAmount || 0;
              // updatedInvoice.trainerAskedPayment =
              //   batchInstructorEntry.mouAmount || 0;
              updatedInvoice.leaves = batchInstructorEntry.trainerLeaves || 0;
            }
          }
        }
      } else {
        // Clear all fields if no match is found (removed UPI, PAN, Bank clearing)
        updatedInvoice.trainerName = "";
        updatedInvoice.instructor_contact = "";
        updatedInvoice.dateOfAssign = "";
        updatedInvoice.mouHours = "";
        updatedInvoice.mouAmount = 0;
        updatedInvoice.trainerLeaves = 0;
        updatedInvoice.attendedHours = "";
        updatedInvoice.classes = 0;
        updatedInvoice.numClassesAsMOU = 0;
        updatedInvoice.costAsPerMOU = 0;
        // updatedInvoice.trainerAskedPayment = 0;
        updatedInvoice.leaves = 0;
      }
    }

    setSelectedInvoice(updatedInvoice);
  };

  // Enhanced search function that works with filtered instructors
  const handleInstructorSearch: OptionsFilter = ({ options, search }) => {
    const instructorsToSearch =
      filteredInstructors.length > 0
        ? filteredInstructors
        : instructorsRef.current;

    if (!search) {
      return instructorsToSearch.map(({ email }) => ({
        label: email || "",
        value: email || "",
      }));
    }

    const filteredOptions: ComboboxItem[] = [];

    instructorsToSearch.forEach(({ email, name, contact }) => {
      const searchItem = search?.toLowerCase();

      const emailLower = email ? email.toLowerCase() : "";
      const nameLower = name ? name.toLowerCase() : "";
      const contactLower = contact ? contact.toLowerCase() : "";

      if (
        emailLower.includes(searchItem) ||
        nameLower.includes(searchItem) ||
        contactLower.includes(searchItem)
      ) {
        filteredOptions.push({
          label: email || "",
          value: email || "",
        });
      }
    });

    return filteredOptions;
  };

  const handleInvoiceClick = (invoice: InvoiceData) => {
    // Set the selected invoice
    setSelectedInvoice(invoice);

    // Find the corresponding batch in allBatches
    const selectedBatch = allBatches.find(
      (b) => b.batch_no === String(invoice.batchNumber1),
    );

    // Set the primary batch number
    setPrimaryBatchNo(
      invoice.batchNumber1 ? invoice.batchNumber1.toString() : null,
    );

    // Set batch numbers 2 and 3 based on the batch's linked batches or the invoice data
    if (selectedBatch?.linkedBatches?.length) {
      const [linked1, linked2] = selectedBatch.linkedBatches;
      setBatchNo2(linked1 || "");
      setBatchNo3(linked2 || "");
    } else {
      // Use the values from the invoice if they exist
      setBatchNo2(
        invoice.batchNumber2 && invoice.batchNumber2 !== 0
          ? invoice.batchNumber2.toString()
          : "",
      );
      setBatchNo3(
        invoice.batchNumber3 && invoice.batchNumber3 !== 0
          ? invoice.batchNumber3.toString()
          : "",
      );
    }

    // Open the modal
    setIsModalOpen(true);

    // Get duplicates if needed
    getDuplicates(
      [invoice.batchNumber1, invoice.batchNumber2, invoice.batchNumber3].filter(
        Boolean,
      ),
    );
  };

  // Function to open the modal for duplicate invoice
  const handleDuplicateInvoiceClick = (invoiceId: string) => {
    const foundInvoice = tableData.find(
      (invoice) => invoice.inv_no === invoiceId,
    );
    if (foundInvoice) {
      setSelectedInvoice(foundInvoice);
      setIsDuplicateModalOpen(true);
    } else {
      setError("Invoice not found.");
    }
  };

  const handleEditClick = () => {
    setIsEditing((prev) => !prev); // Toggle edit mode on "Edit" button click
  };
  // Function to handle click on any editable field

  const handleFieldClick = (e: React.MouseEvent) => {
    if (!isEditing) {
      e.preventDefault(); // Prevent the default action (focus on input)
    }
  };

  // Handler for updating a specific student name
  const handleStudentNameChange = (index: number, value: string) => {
    const updatedNames = [...(formData.studentNames || [])]; // Ensure the array exists
    updatedNames[index] = value; // Update the specific index
    setFormData((prev) => ({
      ...prev,
      studentNames: updatedNames,
    }));
  };

  const addStudentNameFieldInModal = () => {
    setSelectedInvoice((prev) => {
      if (prev) {
        return {
          ...prev,
          studentNames: [...(prev.studentNames || []), ""],
          numOfClasses: [...(prev.numOfClasses || []), ""],
        };
      }
      return null;
    });
  };

  const handleNumOfClassesChange = (index: number, value: string) => {
    const updatedClasses = [...(formData.numOfClasses || [])];
    updatedClasses[index] = value; // Update the specific index
    setFormData((prev) => ({
      ...prev,
      numOfClasses: updatedClasses,
    }));
  };

  // Handler for adding a new student name field
  const addStudentNameField = () => {
    setFormData((prev) => ({
      ...prev,
      studentNames: [...(prev.studentNames || []), ""],
      numOfClasses: [...(prev.numOfClasses || []), ""], // Add an empty entry
    }));
  };

  // Handler for removing a student name field
  const removeStudentNameField = (index: number) => {
    const updatedNames = (formData.studentNames || []).filter(
      (_, i) => i !== index,
    );
    const updatedClasses = (formData.numOfClasses || []).filter(
      (_, i) => i !== index,
    );
    setFormData((prev) => ({
      ...prev,
      studentNames: updatedNames,
      numOfClasses: updatedClasses,
    }));
  };
  useEffect(() => {
    if (selectedInvoice?.studentMap) {
      const studentArray = Object.entries(selectedInvoice.studentMap).map(
        ([name, value]) => ({
          name,
          numOfClasses: value.N, // Assuming 'N' is the number of classes
        }),
      );
      setSelectedInvoice((prev) => ({
        ...prev!,
        studentDetails: studentArray,
      }));
    }
  }, [selectedInvoice?.studentMap]);

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
    // setIsDuplicateModalOpen(false)
    setSelectedInvoice(null);
  };

  // Function to close Duplicate modal

  const closeDuplicateModal = () => {
    setIsDuplicateModalOpen(false);
  };

  useEffect(() => {
    // getDuplicates();
  }, []); // Triggered on component mount

  const getDuplicates = async (batchNumbers: any[]) => {
    setLoading(true);
    setError(null);

    // Filter out null, empty, or 0 values before sending to backend
    const filteredBatchNumbers = batchNumbers.filter(
      (num) => num !== null && num !== "" && num !== 0,
    );

    try {
      // Call getAllDuplicate with the filtered batch numbers to find duplicates
      const response = await getAllDuplicate(
        "tc-invoice-details-trainers",
        filteredBatchNumbers,
      );

      if (response?.data) {
        setDuplicatess(response.data); // Assuming the response has a 'duplicates' field
      } else {
        setError("No duplicates found or error in fetching duplicates.");
      }
    } catch (err) {
      setError("Error fetching duplicates.");
    } finally {
      setLoading(false);
    }
  };

  const handleShowDuplicates = () => {
    setIsDuplicateModalOpen(true);
    // getDuplicates(); // Optionally reload duplicates when opening the modal
  };

  // Columns for Ant Design Table
  const columns = [
    {
      title: "Batch Number",
      dataIndex: "batchNumber",
      key: "batchNumber",
    },
    {
      title: "IDs",
      dataIndex: "ids",
      key: "ids",
      render: (ids: string[]) => ids.join(", "),
    },
  ];

  function extractInvoiceNumber(invNo: string): number {
    const match = invNo.match(/\d+/); // Extracts digits from string
    return match ? parseInt(match[0], 10) : 0;
  }
  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const response = await ApiService.getInstance().get(
        "/tc-invoice-details-trainers",
      );

      const allInvoices = response.data.data;

      const sorted = allInvoices.sort(
        (a: InvoiceData, b: InvoiceData) =>
          extractInvoiceNumber(b.inv_no) - extractInvoiceNumber(a.inv_no),
      );

      setTableData(sorted);
      setFilteredData(sorted);
    } catch (err) {
      console.error("Fetch All Error:", err);
      setError("Failed to fetch all invoice data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices(); // Fetch everything once at mount
  }, []);

  const filteredCount = useMemo(() => filteredData.length, [filteredData]);

  const statusCount = useMemo(() => {
    const countMap: Record<string, number> = {};
    filteredData.forEach((invoice) => {
      const status = invoice.status || "Unknown";
      countMap[status] = (countMap[status] || 0) + 1;
    });
    return countMap;
  }, [filteredData]);

  // const statusSummary = useMemo(() => {
  //   const summaryMap: Record<
  //     string,
  //     { count: number; netPayable: number; tds: number }
  //   > = {};

  //   filteredData.forEach((invoice) => {
  //     const status = invoice.status || "Unknown";
  //     const netPayable = Number(invoice.netPayable) || 0;
  //     const tds = Number(invoice.tds) || 0;

  //     if (!summaryMap[status]) {
  //       summaryMap[status] = { count: 0, netPayable: 0, tds: 0 };
  //     }

  //     summaryMap[status].count += 1;
  //     summaryMap[status].netPayable += netPayable;
  //     summaryMap[status].tds += tds;
  //   });

  //   return summaryMap;
  // }, [filteredData]);

  const statusSummary = useMemo(() => {
    const summaryMap: Record<
      string,
      { count: number; netPayable: number; tds: number }
    > = {};

    filteredData.forEach((invoice) => {
      const rawStatus =
        typeof invoice.status === "string" ? invoice.status : "";
      const status = rawStatus.trim();

      const netPayable = Number(invoice.netPayable) || 0;
      const tds = Number(invoice.tds) || 0;

      if (!summaryMap[status]) {
        summaryMap[status] = { count: 0, netPayable: 0, tds: 0 };
      }

      summaryMap[status].count += 1;
      summaryMap[status].netPayable += netPayable;
      summaryMap[status].tds += tds;
    });

    return summaryMap;
  }, [filteredData]);

  function getInvoiceAge(invoiceDate?: string | Date): string {
    if (!invoiceDate) return "N/A";

    const invoice = new Date(invoiceDate);
    if (isNaN(invoice.getTime())) return "Invalid Date";

    const now = new Date();
    const diffMilliseconds = now.getTime() - invoice.getTime();

    if (diffMilliseconds < 0) return "Future Date";

    const diffHours = Math.floor(diffMilliseconds / (1000 * 60 * 60));

    if (diffHours < 24) {
      return `${diffHours} hrs`;
    } else {
      const diffDays = Math.floor(diffHours / 24);
      return `${diffDays} days`;
    }
  }

  // const studentCount = useMemo(() => {
  //   return filteredData.reduce((sum, invoice) => sum + (invoice.numberOfStudents || 0), 0);
  // }, [filteredData]);

  const [showFilters, setShowFilters] = useState(false);

  const handleClearAllFilters = () => {
    // Clear split filters and the composed unified searchFilter used by filtering logic
    setTrainerFilter("");
    setBatchFilter("");
    setInvoiceFilter("");
    setSearchFilter("");
    setStatusFilter("");
    setStartDateFilter(null);
    setEndDateFilter(null);
  };

  // fetchInvoices()

  useEffect(() => {
    fetchInvoices();
  }, [invoices]);

  // useEffect(() => {
  //   fetchInvoices();
  // }, []);
  // Consolidate all filters into a single useEffect
  useEffect(() => {
    const filtered = tableData.filter((invoice) => {
      const invoiceDate = new Date(invoice.date || "").getTime();
      const startDate = startDateFilter
        ? new Date(startDateFilter).getTime()
        : null;
      const endDate = endDateFilter ? new Date(endDateFilter).getTime() : null;

      // Unified search: support comma-separated tokens so users can search multiple
      // terms at once (e.g. "8800,Shaquib,9990"). We treat tokens as OR across
      // rows: a row is included if any token matches invoice number, trainer
      // name or any batch number (case-insensitive).
      const tokens = (searchFilter || "")
        .split(",")
        .map((t) => t.trim().toLowerCase())
        .filter(Boolean);

      let matchesSearch = true;
      if (tokens.length > 0) {
        matchesSearch = tokens.some((token) => {
          const trainer = invoice.trainerName?.toString().toLowerCase() || "";
          const invNo = invoice.inv_no?.toString().toLowerCase() || "";
          const batches = [
            invoice.batchNumber1,
            invoice.batchNumber2,
            invoice.batchNumber3,
          ].map((b) =>
            b !== undefined && b !== null ? b.toString().toLowerCase() : "",
          );

          // token matches trainer name or invoice no or any batch
          return (
            trainer.includes(token) ||
            invNo.includes(token) ||
            batches.some((b) => b.includes(token))
          );
        });
      }

      return (
        matchesSearch &&
        (!statusFilter ||
          invoice.status?.toLowerCase() === statusFilter.toLowerCase()) &&
        // Date range filter
        (!startDate || invoiceDate >= startDate) &&
        (!endDate || invoiceDate <= endDate)
      );
    });

    setFilteredData(filtered);
  }, [searchFilter, statusFilter, startDateFilter, endDateFilter, tableData]);

  // Define CSV header
  const exportToCSV = () => {
    if (filteredData.length === 0) {
      alert("No data available for export.");
      return;
    }

    //  CSV Headers (FINAL)
    const headers = [
      "Invoice No",
      "Course Name",
      "Batch Number 1",
      "Batch Number 2",
      "Batch Number 3",
      "Date",
      "Payment Clearance Date",
      "Instructor Email",
      "Trainer Name",
      "Instructor Contact",
      "Instructor Bank Account",
      "Instructor UPI ID",
      "Instructor PAN",
      "Classes",
      "Cost as Per MOU",
      "Trainer Asked Payment",
      "TDS Amount",
      "TDS Status",
      "Payment Percentage",
      "Payment Type",
      "Leaves",
      "Leaves Amount Deducted",
      "MOU Hours",
      "Number of Students",
      "Student Names",
      "Number of Classes",
      "Net Payable",
      "Remark",
      "Status",
    ];

    const csvRows = filteredData.map((invoice) => {
      // --------------------------
      //  Extract Student Names
      // --------------------------
      let studentNames = "";
      let numOfClasses = "";

      if (invoice.studentMap) {
        studentNames = Object.keys(invoice.studentMap).join("; ");

        numOfClasses = Object.values(invoice.studentMap)
          .map((val) => {
            if (!val) return "";
            if (typeof val === "number") return val; // New format: "Richard Orr": 44
            if (typeof val === "object") return val.N || ""; // Old format: { N: "25" }
            return "";
          })
          .join("; ");
      }

      return [
        invoice.inv_no || "",
        invoice.courseName || "",
        invoice.batchNumber1 || "",
        invoice.batchNumber2 || "",
        invoice.batchNumber3 || "",
        invoice.date || "",
        invoice.issueDate || "",

        invoice.instructor_email || "",
        invoice.trainerName || "",
        invoice.instructor_contact || "",
        invoice.instructor_bank_account || "",
        invoice.instructor_upi_id || "",
        invoice.instructor_pan || "",

        invoice.classes || "",
        invoice.costAsPerMOU || "",
        invoice.trainerAskedPayment || "",

        // Prefer tds → fallback tdsAmount
        (invoice.tds !== undefined && invoice.tds !== null
          ? invoice.tds
          : invoice.tdsAmount) || "",

        invoice.tdsStatus || "",
        invoice.paymentPercentage || "",
        invoice.paymentType || "",
        invoice.leaves || "",
        invoice.leavesAmountDeducted || "",
        invoice.numClassesAsMOU || "",
        invoice.numberOfStudents || "",

        studentNames,
        numOfClasses,

        invoice.netPayable || "",
        invoice.remark || "",
        invoice.status || "",
      ];
    });

    const csvContent = [headers, ...csvRows]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "filtered_invoices.csv");
  };

  const handleDelete = async (inv_no?: string) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this invoice?",
    );
    if (!confirmDelete) return;

    try {
      // Determine which invoice to delete (from table or modal)
      const invoiceNumberToDelete = inv_no || selectedInvoice?.inv_no;

      if (invoiceNumberToDelete) {
        await ApiService.getInstance().delete(
          `/tc-invoice-details-trainers/${invoiceNumberToDelete}`,
        );
        alert("Invoice deleted successfully!");
        fetchInvoices(); // Refresh the table
        if (!inv_no) closeModal(); // Close modal only if deletion is triggered from the modal
      } else {
        alert("No invoice selected for deletion.");
      }
    } catch (error) {
      console.error("Error deleting invoice:", error);
      alert("Failed to delete invoice.");
    }
  };

  const handleChange = (
    field: keyof InvoiceData,
    value: string | number | boolean,
  ) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    handleCalculate("formData");
  }, [formData.tdsStatus]);

  useEffect(() => {
    if (selectedInvoice) {
      handleCalculate("selectedInvoice");
    }
  }, [selectedInvoice?.tdsStatus]);
  const handleCalculate = (type: "formData" | "selectedInvoice") => {
    let netPayable = 0;
    let calculatedTdsAmount = 0;

    const data = type === "formData" ? formData : selectedInvoice;

    if (data) {
      netPayable =
        (data.trainerAskedPayment || 0) - (data.leavesAmountDeducted || 0);

      // TDS calculation
      const isTdsApplicable = data.tdsStatus === "Yes";
      if (isTdsApplicable) {
        calculatedTdsAmount = netPayable * 0.1; // 10% TDS
        netPayable -= calculatedTdsAmount; // Deduct TDS from netPayable
      }

      // Update the respective state
      if (type === "formData") {
        setFormData((prev) => ({
          ...prev,
          netPayable,
          tds: calculatedTdsAmount,
        }));
      } else {
        setSelectedInvoice((prev) =>
          prev ? { ...prev, netPayable, tds: calculatedTdsAmount } : null,
        );
      }
    }
  };

  // // Checkbox change handler
  // const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const status = e.target.checked ? "Yes" : "No";
  //   setTdsStatus(status); // Update the checkbox status
  //   handleCalculate("formData"); // Recalculate TDS when checkbox is clicked
  // };
  const findDuplicates = (rows: any[], batchKeys: string[]) => {
    const seen = new Map();
    const duplicates: any[] = [];

    rows.forEach((invoice) => {
      batchKeys.forEach((batchKey) => {
        const batchNumber = invoice[batchKey];

        // Skip empty or '0' batch numbers
        if (batchNumber && batchNumber !== 0 && batchNumber !== "0") {
          if (!seen.has(batchNumber)) {
            seen.set(batchNumber, [invoice.inv_no]);
          } else {
            const ids = seen.get(batchNumber);
            ids.push(invoice.inv_no);
            seen.set(batchNumber, ids);

            // Add to duplicates if not already present
            if (!duplicates.some((dup) => dup.batchNumber === batchNumber)) {
              duplicates.push({ batchNumber, ids });
            }
          }
        }
      });
    });

    return duplicates;
  };

  useEffect(() => {
    if (allRows.length > 0) {
      const duplicatesFound = findDuplicates(allRows, [
        "batchNumber1",
        "batchNumber2",
        "batchNumber3",
      ]);
      setDuplicates(duplicatesFound);
    }
  }, [allRows]);

  // Highlight duplicates
  const getBatchStyle = (invoice: any, batchKey: string) => {
    const batchNumber = invoice[batchKey];

    if (
      batchNumber &&
      duplicates.some(
        (duplicate) =>
          duplicate.batchNumber === String(batchNumber) &&
          duplicate.ids.includes(invoice.inv_no),
      )
    ) {
      return {
        color: "red",
        fontWeight: "bold",
      };
    }

    return {
      color: "inherit",
      fontWeight: "normal",
    };
  };

  const handleStatusChange = async (inv_no: string, newStatus: string) => {
    // If "Processing" is selected, update the status immediately in the UI and show the modal

    if (newStatus === "Processing") {
      const invoice = currentRows.find((invoice) => invoice.inv_no === inv_no);
      setSelectedInvoiceForProcessing(invoice || null);
      setShowProcessingModal(true);

      // Optimistically update the UI
      const updatedInvoices = invoices.map((invoice) =>
        invoice.inv_no === inv_no
          ? { ...invoice, status: "Processing" }
          : invoice,
      );
      setInvoices(updatedInvoices);
      try {
        // Call API to update the status
        await fetchUpdateInvoiceStatus(inv_no, "Processing");

        // Fetch the latest invoices to ensure data consistency
        await fetchInvoices();

        showNotification({
          title: "Status Updated",
          message: `Invoice #${inv_no} status updated to Processing.`,
          color: "green",
        });
      } catch (error) {
        console.error("Error updating status:", error);

        // Rollback UI in case of failure
        const previousInvoices = [...invoices];
        setInvoices(previousInvoices);

        showNotification({
          title: "Error",
          message: `Failed to update status for Invoice #${inv_no}.`,
          color: "red",
        });
      }
      return; // Exit the function
    }

    // If "Payment Sent" is selected, open the modal without updating the status
    if (newStatus === "Payment Sent") {
      const invoice = currentRows.find((invoice) => invoice.inv_no === inv_no);
      setSelectedInvoiceForPaymentSent(invoice || null);
      setShowPaymentSentModal(true);
      return; // Do not change the status yet
    }

    // Handle other statuses
    const previousInvoices = [...invoices];
    const updatedInvoices = invoices.map((invoice) =>
      invoice.inv_no === inv_no ? { ...invoice, status: newStatus } : invoice,
    );
    setInvoices(updatedInvoices);

    try {
      // Call API to update the status
      await fetchUpdateInvoiceStatus(inv_no, newStatus);

      // Fetch the latest invoices to refresh the table
      await fetchInvoices();

      showNotification({
        title: "Status Updated",
        message: `Invoice #${inv_no} status updated to ${newStatus}.`,
        color: "green",
      });
    } catch (error) {
      console.error("Error updating status:", error);

      // Rollback UI in case of error
      setInvoices(previousInvoices);

      showNotification({
        title: "Error",
        message: `Failed to update status for Invoice #${inv_no}.`,
        color: "red",
      });
    }
  };

  const handleConfirmProcessing = async () => {
    if (!selectedInvoiceForProcessing) return;

    const inv_no = selectedInvoiceForProcessing.inv_no;

    const updatedInvoices = invoices.map((invoice) =>
      invoice.inv_no === inv_no
        ? { ...invoice, status: "Processing" }
        : invoice,
    );
    setInvoices(updatedInvoices); // Update UI optimistically

    try {
      const response = await fetchUpdateInvoiceStatus(inv_no, "Processing");

      if (response?.inv_no) {
        setInvoices((prevInvoices) =>
          prevInvoices.map((invoice) =>
            invoice.inv_no === response.inv_no
              ? { ...invoice, status: response.status }
              : invoice,
          ),
        );
      }

      showNotification({
        title: "Processing Confirmed",
        message: `Invoice #${inv_no} has been moved to "Processing".`,
        color: "green",
      });
    } catch (error) {
      console.error("Error confirming processing:", error);
      showNotification({
        title: "Error",
        message: `Failed to update status for Invoice #${inv_no}.`,
        color: "red",
      });
    } finally {
      setShowProcessingModal(false); // Close the modal
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case "Approved":
        return "#4CAF50"; // Green for approval or success
      case "Hold":
        return "#FF5722"; // A more distinct reddish-brown for hold status
      case "Open":
        return "#FF9800"; // A bright, distinct orange for open status
      case "Receipt Sent":
        return "#2196F3"; // A strong blue for receipt sent status
      case "Processing":
        return "Black";
      case "Payment Sent":
        return "#00BCD4"; // A teal color for payment sent
      case "Submitted":
        return "#808080";
    }
  };

  const studentMapObject =
    selectedInvoice?.studentMap instanceof Map
      ? Object.fromEntries(selectedInvoice.studentMap)
      : selectedInvoice?.studentMap || {};

  const handleSubmit = async () => {
    try {
      // Filter out invalid batch numbers (undefined or 0)
      const filteredBatchNumbers = [
        formData.batchNumber1,
        formData.batchNumber2,
        formData.batchNumber3,
      ].filter((num) => num !== undefined && num !== 0); // Exclude `undefined` and `0`

      // Only proceed with the request if batch numbers are valid
      const result = await ApiService.getInstance().post(
        "/tc-invoice-details-trainers",
        formData,
      );

      if (result) {
        alert("Invoice submitted successfully!");
        fetchInvoices();
        setShowForm(false);
        setFormData({
          inv_no: "",
          date: "",
          trainerName: "",
          courseName: "",
          batchNumber1: 0, // Reset to 0 after submission (you can change this if needed)
          batchNumber2: 0,
          batchNumber3: 0,
          numberOfStudents: 0,
          leaves: 0,
          classes: 0,
          prorata: false,
          numClassesAsMOU: 0,
          costAsPerMOU: 0,
          trainerAskedPayment: 0,
          tds: 0,
          netPayable: 0,
          status: "Open",
          studentMap: new Map(),
          studentNames: [],
          numOfClasses: [],
          paymentPercentage: 0,
          instructor_bank_account: "",
          instructor_contact: "",
          instructor_email: "",
          instructor_pan: "",
          instructor_upi_id: "",
          leavesAmountDeducted: 0,
          mouHours: "",
          tdsStatus: "No",
          remark: "",
          internalDescription: "",
          dateOfAssign: "",

          mouAmount: 0,
          trainerLeaves: 0,
          attendedHours: "",
        });
      }
    } catch (error) {
      alert("Failed to submit invoice.");
    }
  };

  const getLatestInvoice = async () => {
    try {
      const response = await fetchLatestInvoice("tc-invoice-details-trainers"); //  your correct route

      if (response?.inv_no) {
        setFormData((prev) => ({
          ...prev,
          inv_no: response.inv_no,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          inv_no: "1", // fallback
        }));
      }
    } catch (error) {
      console.error("Error while fetching next invoice number:", error);
      setFormData((prev) => ({
        ...prev,
        inv_no: "1", // fallback on error
      }));
    }
  };

  // Show form and fetch the latest invoice when the user clicks the "Create Invoice" button
  useEffect(() => {
    if (showForm) {
      getLatestInvoice();
    }
  }, [showForm]);

  const formatNumberWithCommas = (value: number | string): string => {
    if (!value) return "";
    const numericValue = typeof value === "string" ? Number(value) : value;
    return numericValue.toLocaleString("en-IN"); // Indian number format
  };

  // Helper function to remove commas and parse the value back to a number
  const parseNumberFromFormattedString = (value: string): number => {
    return Number(value.replace(/,/g, "")); // Remove commas and parse
  };

  return (
    <div className="invoice-page">
      <Container size="md" py="md">
        <Paper
          shadow="sm"
          p="md"
          radius="md"
          withBorder
          style={{
            backgroundColor: "var(--mantine-color-gray-0)",
          }}
        >
          <Group justify="apart" mb="xl">
            <Title order={2}>Invoice </Title>
            <Group gap="sm">
              {/* Create/View Invoice Button with Tooltip */}
              <Tooltip
                label={showForm ? "View Invoice List" : "Create New Invoice"}
              >
                <Button
                  className="invoice-btn"
                  onClick={() => setShowForm(!showForm)}
                  variant="filled"
                  color="blue"
                >
                  <Group gap={8}>
                    {showForm ? <FaEye size={14} /> : <FaPlus size={16} />}
                    <span>{showForm ? "View Invoices" : "Create Invoice"}</span>
                  </Group>
                </Button>
              </Tooltip>

              {/* Filter Button with Tooltip */}
              <Tooltip label="Show Filters">
                <ActionIcon
                  variant="light"
                  color="blue"
                  onClick={() => setShowFilters(!showFilters)}
                  size="lg"
                >
                  <FaFilter size={16} />
                </ActionIcon>
              </Tooltip>

              {/* Reset Button with Tooltip */}
              <Tooltip label="Reset Filters">
                <ActionIcon
                  variant="light"
                  color="gray"
                  onClick={handleClearAllFilters}
                  size="lg"
                >
                  <FaRedo size={16} />
                </ActionIcon>
              </Tooltip>

              {/* Refresh Button with Tooltip */}
              <Tooltip label="Refresh Data">
                <ActionIcon
                  variant="light"
                  color="green"
                  onClick={handleRefresh}
                  size="lg"
                >
                  <FaSync size={16} />
                </ActionIcon>
              </Tooltip>

              {/* Export CSV Button with Tooltip */}
              <Tooltip label="Export to CSV">
                <ActionIcon
                  variant="light"
                  color="violet"
                  onClick={exportToCSV}
                  size="lg"
                >
                  <FaFileCsv size={16} />
                </ActionIcon>
              </Tooltip>

              {/* More Options Menu */}
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <Button variant="outline">More...</Button>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Item onClick={exportToCSV}>Export CSV</Menu.Item>
                  <Menu.Item onClick={() => setIsSummaryOpen(true)}>
                    Calculate
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
              <Tooltip label="Update all Open/Submitted invoice hours">
                <UpdateHoursButton />
              </Tooltip>
            </Group>
          </Group>

          {/* Last Refreshed Time */}
          {lastRefreshTime && (
            <Text size="xs" mb="md">
              Last Refreshed: <strong>{lastRefreshTime}</strong>
            </Text>
          )}

          {/* Filter Component - Replace with your actual filter component */}
          {showFilters && (
            <Paper p="md" mb="md" shadow="xs">
              <div
                className="search-section"
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "flex-end",
                  flexWrap: "wrap",
                }}
              >
                {/* Trainer Name Filter */}
                <TextInput
                  label="Trainer"
                  placeholder="Search by Trainer Name"
                  value={trainerFilter}
                  onChange={(e) => {
                    const val = e.target.value;
                    setTrainerFilter(val);
                    const tokens = [val, batchFilter, invoiceFilter]
                      .filter(Boolean)
                      .join(",");
                    setSearchFilter(tokens);
                  }}
                  style={{ flex: 1, minWidth: 200 }}
                />

                {/* Batch Number Filter */}
                <TextInput
                  label="Batch"
                  placeholder="Search by Batch Number"
                  value={batchFilter}
                  onChange={(e) => {
                    const val = e.target.value;
                    setBatchFilter(val);
                    const tokens = [trainerFilter, val, invoiceFilter]
                      .filter(Boolean)
                      .join(",");
                    setSearchFilter(tokens);
                  }}
                  style={{ flex: 1, minWidth: 160 }}
                />

                {/* Invoice Number Filter */}
                <TextInput
                  label="Invoice No"
                  placeholder="Search by Invoice Number"
                  value={invoiceFilter}
                  onChange={(e) => {
                    const val = e.target.value;
                    setInvoiceFilter(val);
                    const tokens = [trainerFilter, batchFilter, val]
                      .filter(Boolean)
                      .join(",");
                    setSearchFilter(tokens);
                  }}
                  style={{ flex: 1, minWidth: 160 }}
                />

                {/* Status Filter */}
                <Select
                  label="Status"
                  placeholder="Select Status"
                  value={statusFilter || null}
                  onChange={(value) => setStatusFilter(value || "")}
                  data={[
                    { value: "Approved", label: "Approved" },
                    { value: "Hold", label: "Hold" },
                    { value: "Open", label: "Open" },
                    { value: "Receipt Sent", label: "Receipt Sent" },
                    { value: "Processing", label: "Processing" },
                    { value: "Payment Sent", label: "Payment Sent" },
                    { value: "Submitted", label: "Submitted" },
                  ]}
                  clearable
                  style={{ minWidth: 170 }}
                />

                {/* Date Range Filter */}
                <TextInput
                  label="Start Date"
                  type="date"
                  value={startDateFilter || ""}
                  onChange={(e) => setStartDateFilter(e.target.value)}
                  style={{ width: 160 }}
                />

                <TextInput
                  label="End Date"
                  type="date"
                  value={endDateFilter || ""}
                  onChange={(e) => setEndDateFilter(e.target.value)}
                  style={{ width: 160 }}
                />

                {/* Keep a small Clear button visible on the row (optional) */}
                <div style={{ marginLeft: "auto" }}>
                  <Button
                    size="sm"
                    onClick={handleClearAllFilters}
                    color="gray"
                  >
                    Clear
                  </Button>
                </div>
              </div>
            </Paper>
          )}

          {/* Error/Success Notifications */}
          {error && (
            <Notification color="red" mb="md" onClose={() => setError("")}>
              {error}
            </Notification>
          )}

          {successMessage && (
            <Notification
              color="green"
              mb="md"
              onClose={() => setSuccessMessage("")}
            >
              {successMessage}
            </Notification>
          )}

          {/* Show Loading State */}
          {loading && <p className="text-center">Loading...</p>}

          {error && <Notification color="red">{error}</Notification>}

          {/* Show Loading State */}
          {loading && <p>Loading duplicates...</p>}

          {showForm ? (
            <div className="invoice-form">
              <h2 style={{ textAlign: "center", marginBottom: "1rem" }}>
                Create Invoice
              </h2>

              <div style={{ display: "flex", gap: "1rem" }}>
                <TextInput
                  label="Invoice No"
                  value={formData.inv_no}
                  onChange={(e) => handleChange("inv_no", e.target.value)}
                  required
                />

                {/* Date */}
                <TextInput
                  label="Date"
                  value={formData.date}
                  onChange={(e) => handleChange("date", e.target.value)}
                  type="date"
                  required
                  style={{ flex: 1 }}
                />

                {/* Input field showing dynamic user data */}
                <TextInput
                  label="Created By"
                  value={`${user?.firstName} ${user?.lastName}`} // Set user name dynamically
                  required
                  readOnly
                  style={{ flex: 1 }}
                />
              </div>

              <Divider my="lg" />

              {/* Student Info Section */}
              <div className="box student-info">
                <h2>Student Info</h2>

                {/* Number of Students */}
                <TextInput
                  label="Number of Students"
                  value={formData.numberOfStudents || ""}
                  onChange={(e) =>
                    handleChange("numberOfStudents", +e.target.value)
                  }
                />

                {/* Student Details */}
                <Flex direction="row" wrap="wrap" align="center" gap="md">
                  {(formData.studentNames || []).map((name, index) => (
                    <Group key={index} mt="sm" align="center" grow>
                      {/* Name of Student */}
                      <TextInput
                        label="Name of Student"
                        placeholder={`Student ${index + 1}`}
                        value={name}
                        onChange={(e) =>
                          handleStudentNameChange(index, e.target.value)
                        }
                      />

                      {/* Number of Classes */}
                      <TextInput
                        label="No. of Classes"
                        placeholder="Enter number of classes"
                        value={
                          (formData.numOfClasses &&
                            formData.numOfClasses[index]) ||
                          ""
                        }
                        onChange={(e) =>
                          handleNumOfClassesChange(index, e.target.value)
                        }
                      />

                      {/* Remove Student */}
                      <Button
                        style={{ marginTop: "25px" }}
                        color="red"
                        onClick={() => removeStudentNameField(index)}
                      >
                        <span style={{ fontSize: "13px" }}>Remove</span>
                      </Button>
                    </Group>
                  ))}
                </Flex>

                {/* Add Student Button */}
                <Button mt="sm" onClick={addStudentNameField}>
                  + Add Student
                </Button>
              </div>

              <Divider my="lg" />

              {/* Batch Info Section */}
              <div className="box batch-info">
                <h2>Batch Info</h2>

                {/* Row 1: Batch 1 (Primary), Batch 2, Batch 3 */}
                {/* Row 1: Batch 1 (Primary), Batch 2, Batch 3 */}
                <Flex direction="row" wrap="wrap" align="center" gap="md">
                  <Select
                    label="Batch 1"
                    value={
                      formData.batchNumber1
                        ? formData.batchNumber1.toString()
                        : ""
                    }
                    onChange={handleBatchSelection} // Use the new enhanced function
                    data={batchOptions}
                    searchable
                    placeholder="Select Batch 1"
                    style={{ flex: 1 }}
                  />

                  <TextInput
                    label="Batch 2"
                    value={formData.batchNumber2?.toString() ?? ""}
                    readOnly
                    style={{ flex: 1 }}
                  />

                  <TextInput
                    label="Batch 3"
                    value={formData.batchNumber3?.toString() ?? ""}
                    readOnly
                    style={{ flex: 1 }}
                  />
                </Flex>

                {/* Row 2: Course Name, No. of Trainer Leaves, No. of Classes */}
                <Flex direction="row" wrap="wrap" align="center" gap="md">
                  <TextInput
                    label="Course Name"
                    value={formData.courseName || ""}
                    onChange={(e) => handleChange("courseName", e.target.value)}
                    style={{ flex: 1 }}
                  />
                  <TextInput
                    label="No. of Trainer Leaves"
                    value={formData.leaves || ""}
                    onChange={(e) => handleChange("leaves", +e.target.value)}
                    style={{ flex: 1 }}
                  />
                  <TextInput
                    label="No. of Hours"
                    value={formData.classes || ""}
                    onChange={(e) => handleChange("classes", +e.target.value)}
                    style={{ flex: 1 }}
                  />
                </Flex>

                {/* Row 3: Classes As Per MOU, Cost As Per MOU, Trainer Asked for Payment */}
                <Flex direction="row" wrap="wrap" align="center" gap="md">
                  <TextInput
                    label="Classes As Per MOU"
                    value={formData.numClassesAsMOU || ""}
                    onChange={(e) =>
                      handleChange("numClassesAsMOU", +e.target.value)
                    }
                    style={{ flex: 1 }}
                  />
                  <TextInput
                    label="MOU Amount (Per Student)"
                    value={formatNumberWithCommas(formData.costAsPerMOU || 0)} // Display formatted value
                    onChange={(e) =>
                      handleChange(
                        "costAsPerMOU",
                        parseNumberFromFormattedString(e.target.value), // Remove commas and store raw value
                      )
                    }
                    style={{ flex: 1 }}
                  />
                  <TextInput
                    label="Trainer Amount (As Per Invoice)"
                    value={formatNumberWithCommas(
                      formData.trainerAskedPayment || 0,
                    )} // Format value with commas
                    onChange={(e) => {
                      const rawValue = parseNumberFromFormattedString(
                        e.target.value,
                      ); // Remove commas
                      handleChange("trainerAskedPayment", rawValue); // Update raw value in state
                    }}
                    placeholder="Enter amount"
                    style={{ flex: 1 }}
                  />
                </Flex>

                {/* Remark Section */}
                <div className="Remark-info">
                  <h2>Remarks</h2>
                  <Textarea
                    label="Remark"
                    placeholder="Enter remark (e.g., Demo/Interview Session)"
                    value={formData.remark}
                    onChange={(e) => handleChange("remark", e.target.value)}
                  />
                  <Textarea
                    label="Internal Description"
                    description="Visible to the internal team only"
                    placeholder="Add internal pointers for this invoice"
                    value={formData.internalDescription}
                    onChange={(e) =>
                      handleChange("internalDescription", e.target.value)
                    }
                    minRows={3}
                    resize="vertical"
                    mt="sm"
                  />
                </div>
              </div>

              <Divider my="lg" />
              {/* Trainer Info Section */}
              <div className="box trainer-info">
                <h2>Trainer Info</h2>
                <Button onClick={() => setOpened(true)}>
                  Add New Instructor
                </Button>

                <Modal
                  opened={opened}
                  onClose={() => setOpened(false)}
                  title="Add New Instructor"
                  size="md"
                  className="compact-modal"
                >
                  <LoadingOverlay visible={loading} />

                  <form
                    onSubmit={form.onSubmit((values) =>
                      handleCreateInstructor(values),
                    )}
                  >
                    <TextInput
                      label="Name"
                      placeholder="Enter instructor's name"
                      {...form.getInputProps("name")}
                      required
                    />

                    <TextInput
                      label="Email"
                      placeholder="Enter instructor's email"
                      {...form.getInputProps("email")}
                      required
                    />

                    <NumberInput
                      label="SNO"
                      value={form.values.sno}
                      readOnly
                      disabled
                    />

                    <TextInput
                      label="Contact"
                      placeholder="Enter contact number"
                      {...form.getInputProps("contact")}
                    />

                    <Textarea
                      label="Tags"
                      placeholder="Enter tags (comma-separated)"
                      {...form.getInputProps("tags")}
                    />

                    <TextInput
                      label="UPI ID"
                      placeholder="Enter UPI ID"
                      {...form.getInputProps("instructor_upi_id")}
                    />

                    <TextInput
                      label="PAN"
                      placeholder="Enter PAN number"
                      {...form.getInputProps("instructor_pan")}
                    />

                    <Textarea
                      label="Bank Account"
                      placeholder="Enter bank account number"
                      {...form.getInputProps("instructor_bank_account")}
                    />

                    <Group justify="right" mt="md">
                      <Button type="submit" color="blue" loading={loading}>
                        Submit
                      </Button>
                      <Button color="gray" onClick={() => setOpened(false)}>
                        Cancel
                      </Button>
                    </Group>
                  </form>
                </Modal>

                {/* Create a row for the first three inputs */}
                <div style={{ display: "flex", gap: "1rem" }}>
                  <Select
                    label="Trainer Email ID"
                    id="email"
                    name="instructor_email"
                    data={instructors}
                    value={formData.instructor_email}
                    searchable
                    required={true}
                    onChange={(val) =>
                      handleChangeCommon("instructor_email", val)
                    }
                    placeholder="Select Email"
                    nothingFoundMessage="Nothing found..."
                    filter={handleInstructorSearch}
                    style={{ flex: 1 }}
                  />
                  <TextInput
                    label="Trainer Name"
                    value={formData.trainerName || ""}
                    onChange={(e) =>
                      handleChange("trainerName", e.target.value)
                    }
                    style={{ flex: 1 }}
                  />

                  <TextInput
                    label="Trainer Phone No."
                    value={formData.instructor_contact || ""}
                    onChange={(e) =>
                      handleChange("instructor_contact", e.target.value)
                    }
                    style={{ flex: 1 }}
                  />
                </div>

                {/* Create a row for the next three inputs */}
                <div
                  style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}
                >
                  <TextInput
                    label="Trainer UPI"
                    value={formData.instructor_upi_id || ""}
                    onChange={(e) =>
                      handleChange("instructor_upi_id", e.target.value)
                    }
                    style={{ flex: 1 }}
                  />
                  <TextInput
                    label="Trainer PAN"
                    value={formData.instructor_pan || ""}
                    onChange={(e) =>
                      handleChange(
                        "instructor_pan",
                        e.target.value.toUpperCase(),
                      )
                    }
                    style={{ flex: 1 }}
                  />
                  <Textarea
                    label="Trainer Bank Details"
                    value={formData.instructor_bank_account || ""}
                    onChange={(e) =>
                      handleChange("instructor_bank_account", e.target.value)
                    }
                    autosize
                    minRows={3} // Minimum rows (default height)
                    maxRows={8} // Maximum rows before scroll appears
                    style={{ flex: 1 }}
                  />
                </div>
              </div>

              <Divider my="lg" />
              {/*  First Row: Approved By, Deduction, Payment Percentage */}
              <Flex direction="row" wrap="wrap" align="center" gap="md">
                {/*  Approved By */}
                <TextInput
                  label="Approved By"
                  value={formData.approvedBy || ""}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      approvedBy: e.target.value,
                    }))
                  }
                  placeholder={`Enter approver's name ${
                    user ? `(e.g., ${user.firstName} ${user.lastName})` : ""
                  }`}
                  style={{ flex: 1, minWidth: "200px" }}
                  required
                />

                {/*  Deduction Field */}
                <TextInput
                  label="Deduction"
                  value={formData.leavesAmountDeducted || ""}
                  onChange={(e) =>
                    handleChange("leavesAmountDeducted", +e.target.value)
                  }
                  style={{ flex: 1, minWidth: "200px" }}
                />

                {/*  Payment Type Radio Button */}
                <Flex direction="column" style={{ flex: 1, minWidth: "200px" }}>
                  <label style={{ fontWeight: "bold", fontSize: "14px" }}>
                    Payment Type
                  </label>
                  <Radio.Group
                    value={formData.paymentType || ""}
                    onChange={(value) => {
                      handleChange("paymentType", value);

                      //  Auto-set Slider value for Full
                      if (value === "full") {
                        handleChange("paymentPercentage", 100);
                      } else if (value === "prorata") {
                        handleChange("paymentPercentage", 0); //  Disable Slider on Prorata
                      }
                    }}
                  >
                    <Flex direction="column" gap="xs">
                      <Radio value="first" label="First" />
                      <Radio value="last" label="Last" />
                      <Radio value="prorata" label="Prorata" />
                      <Radio value="full" label="Full" />
                    </Flex>
                  </Radio.Group>
                </Flex>

                {/*  Payment Percentage (Slider) */}
                <Flex direction="column" style={{ flex: 1, minWidth: "200px" }}>
                  <label style={{ fontWeight: "bold", fontSize: "14px" }}>
                    Payment Percentage
                  </label>
                  <Slider
                    value={
                      formData.paymentType === "full"
                        ? 100
                        : formData.paymentPercentage || 0
                    } //  Full = 100%
                    onChange={(value) =>
                      handleChange("paymentPercentage", Number(value) || 0)
                    }
                    min={0}
                    max={100}
                    step={25}
                    marks={[
                      { value: 0, label: "0%" },
                      { value: 25, label: "25%" },
                      { value: 50, label: "50%" },
                      { value: 75, label: "75%" },
                      { value: 100, label: "100%" },
                    ]}
                    disabled={formData.paymentType === "prorata"} //  Disable on Prorata
                    styles={{
                      track: {
                        height: "8px",
                        background: "linear-gradient(90deg, #ff9a9e, #fad0c4)",
                      },
                      thumb: {
                        width: "18px",
                        height: "18px",
                        backgroundColor: "white",
                        border: "3px solid #ff6f61",
                        borderRadius: "50%",
                      },
                      markLabel: {
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#444",
                      },
                    }}
                  />
                </Flex>

                {/*  TDS Applicable Checkbox */}
                <Flex direction="column" style={{ flex: 1, minWidth: "200px" }}>
                  <Checkbox
                    label="TDS Applicable"
                    checked={formData.tdsStatus === "Yes"}
                    onChange={(e) => {
                      const isChecked = e.currentTarget.checked;
                      setFormData((prev) => ({
                        ...prev,
                        tdsStatus: isChecked ? "Yes" : "No",
                      }));
                      setSelectedInvoice((prev) =>
                        prev
                          ? { ...prev, tdsStatus: isChecked ? "Yes" : "No" }
                          : null,
                      );
                    }}
                  />
                  {formData.tdsStatus === "Yes" && (
                    <TextInput
                      label="TDS Amount"
                      value={formData.tds ? `₹${formData.tds.toFixed(2)}` : ""}
                      readOnly
                    />
                  )}
                </Flex>

                {/*  Net Payable Field */}
                <TextInput
                  label="Net Payable"
                  value={formatNumberWithCommas(formData.netPayable || 0)}
                  onChange={(e) =>
                    handleChange(
                      "netPayable",
                      parseNumberFromFormattedString(e.target.value),
                    )
                  }
                  style={{ flex: 1, minWidth: "200px" }}
                />
              </Flex>

              <Divider my="lg" />

              {/* Form Actions */}
              <div
                style={{
                  display: "flex",
                  // justifyContent: "space-between",
                  marginTop: "1.5rem",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Button onClick={() => handleCalculate("formData")}>
                  Calculate
                </Button>
                <Button onClick={handleSubmit}>Submit</Button>
                <Button color="red" onClick={() => setShowForm(false)}>
                  Cancel
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div>
                <div>
                  <div
                    style={{ display: "flex", gap: "20px", padding: "10px 0" }}
                  >
                    <p>
                      <strong>Total Records:</strong> {filteredCount}
                    </p>
                  </div>

                  {/* Status-wise Count - this is for Specific Status shown */}
                  {/* <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", }}>
  {Object.entries(statusCount).map(([status, count]) => (
    <span key={status} style={{ padding: "5px 10px", border: "1px solid gray", borderRadius: "5px" }}>
      <strong>{status}:</strong> {count}
    </span>
  ))}
</div> */}

                  {/* Status-wise Count with Amount Shown  */}
                  {/* <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
  {Object.entries(statusSummary).map(([status, data]) => (
    <span
      key={status}
      style={{
        padding: "5px 10px",
        border: "1px solid gray",
        borderRadius: "5px",
      }}
    >
      <strong>{status}:</strong> {data.count} | ₹{data.amount.toFixed(2)}
    </span>
  ))}
</div> */}
                </div>
              </div>
              <div className="pagination-controls">
                <Button
                  className="pagination-btn"
                  size="xs"
                  disabled={currentPage === 1}
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                >
                  Previous
                </Button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <Button
                  className="pagination-btn"
                  size="xs"
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                >
                  Next
                </Button>
                <select
                  value={rowsPerPage}
                  onChange={(e) => {
                    setRowsPerPage(Number(e.target.value));
                    setCurrentPage(1); // Reset to the first page on rows-per-page change
                  }}
                >
                  <option value={15}>15 data per page</option>
                  <option value={20}>20 data per page</option>
                  <option value={40}>40 data per page</option>
                  <option value={100}>100 data per page</option>
                  <option value={500}>500 data per page</option>
                  <option value={1000}>1000 data per page</option>
                </select>
              </div>

              {loading ? (
                <Center style={{ marginTop: "10px" }}>
                  <Loader size="xl" />
                </Center>
              ) : error ? (
                <Notification
                  color="red"
                  title="Error"
                  style={{ marginTop: "10px" }}
                >
                  {error}
                </Notification>
              ) : (
                <>
                  <div className="invoice-table">
                    <Table
                      highlightOnHover
                      striped
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        marginTop: "10px",
                      }}
                    >
                      <Table.Thead>
                        <Table.Tr>
                          <Table.Th style={{ width: "10%" }}>
                            Invoice No
                          </Table.Th>
                          <Table.Th style={{ width: "20%" }}>Date</Table.Th>
                          <Table.Th style={{ width: "15%" }}>
                            Trainer Name
                          </Table.Th>
                          <Table.Th style={{ width: "10%" }}>Batch1</Table.Th>
                          <Table.Th style={{ width: "10%" }}>Batch2</Table.Th>
                          <Table.Th style={{ width: "10%" }}>Batch3</Table.Th>
                          <Table.Th style={{ width: "10%" }}>Payment</Table.Th>
                          <Table.Th style={{ width: "10%" }}>
                            Net Payable
                          </Table.Th>
                          <Table.Th style={{ width: "10%" }}>Age</Table.Th>

                          <Table.Th style={{ width: "10%" }}>Status</Table.Th>
                          <Table.Th style={{ width: "10%" }}>Actions</Table.Th>
                        </Table.Tr>
                      </Table.Thead>
                      <Table.Tbody>
                        {currentRowss.map((invoice) => (
                          <Table.Tr key={invoice.inv_no}>
                            <Table.Td>
                              <Button
                                onClick={() => handleInvoiceClick(invoice)}
                                style={{
                                  cursor: "pointer",
                                  margin: "0",
                                  minWidth: "60px",
                                  backgroundColor: "#6ea8f3",
                                  color: "white",
                                }}
                              >
                                {invoice.inv_no}
                              </Button>
                            </Table.Td>
                            <Table.Td>
                              {invoice.date
                                ? new Date(invoice.date).toLocaleDateString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                    },
                                  )
                                : "N/A"}
                            </Table.Td>
                            <Table.Td>{invoice.trainerName || "N/A"}</Table.Td>
                            <Table.Td
                              style={getBatchStyle(invoice, "batchNumber1")}
                            >
                              {invoice.batchNumber1 || "N/A"}
                            </Table.Td>
                            <Table.Td
                              style={getBatchStyle(invoice, "batchNumber2")}
                            >
                              {invoice.batchNumber2 || "N/A"}
                            </Table.Td>
                            <Table.Td
                              style={getBatchStyle(invoice, "batchNumber3")}
                            >
                              {invoice.batchNumber3 || "N/A"}
                            </Table.Td>
                            <Table.Td>
                              ₹
                              {formatNumberWithCommas(
                                invoice.trainerAskedPayment || 0,
                              )}
                            </Table.Td>
                            <Table.Td>
                              ₹{formatNumberWithCommas(invoice.netPayable ?? 0)}
                            </Table.Td>
                            <Table.Td>{getInvoiceAge(invoice.date)}</Table.Td>

                            <Table.Td>
                              <select
                                value={invoice.status}
                                onChange={(e) =>
                                  handleStatusChange(
                                    invoice.inv_no,
                                    e.target.value,
                                  )
                                }
                                style={{
                                  padding: "5px",
                                  fontSize: "11px",
                                  borderRadius: "5px",
                                  width: "110px",
                                  textAlign: "center",
                                  backgroundColor: getStatusColor(
                                    invoice.status || "Open",
                                  ),
                                  color: "white",
                                  fontWeight: "bold",
                                  border: "1px solid #ccc",
                                  cursor: "pointer",
                                }}
                              >
                                <option value="Approved">Approved</option>
                                <option value="Hold">Hold</option>
                                <option value="Open">Open</option>
                                <option value="Receipt Sent">
                                  Receipt Sent
                                </option>
                                <option value="Processing">Processing</option>
                                <option value="Payment Sent">
                                  Payment Sent
                                </option>
                                <option value="Submitted">Submitted</option>{" "}
                                {/* Add this option */}
                              </select>
                            </Table.Td>

                            <Table.Td>
                              <Button
                                onClick={() => handleDelete(invoice.inv_no)}
                                color="red"
                                size="xs"
                                style={{
                                  backgroundColor: "red",
                                  padding: "2px 5px",
                                  margin: "0",
                                  fontSize: "10px",
                                  width: "55px",
                                  height: "25px",
                                }}
                              >
                                Delete
                              </Button>
                            </Table.Td>
                          </Table.Tr>
                        ))}
                      </Table.Tbody>
                    </Table>
                  </div>

                  <div className="invoice-cards">
                    {currentRowss.map((invoice) => (
                      <div className="invoice-card" key={invoice.inv_no}>
                        {/* Header Section */}
                        <div className="card-header">
                          <Button
                            onClick={() => handleInvoiceClick(invoice)}
                            className="card-inv-btn"
                            style={{
                              backgroundColor: "#1864ab",
                              color: "white",
                              minWidth: "56px",
                            }}
                          >
                            {invoice.inv_no}
                          </Button>

                          <div className="card-date">
                            {invoice.date
                              ? new Date(invoice.date).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  },
                                )
                              : "N/A"}
                          </div>

                          {/* Collapse Icon */}
                          <Button
                            variant="subtle"
                            color="gray"
                            onClick={() => toggleCard(invoice.inv_no)}
                            style={{ padding: "2px 6px" }}
                          >
                            {openCards[invoice.inv_no] ? (
                              <ChevronUp size={18} />
                            ) : (
                              <ChevronDown size={18} />
                            )}
                          </Button>
                        </div>

                        {/* Always visible info */}
                        <div className="card-body">
                          <div className="card-row">
                            <div className="card-label">Trainer</div>
                            <div className="card-value">
                              {invoice.trainerName || "N/A"}
                            </div>
                          </div>

                          <div className="card-row">
                            <div className="card-label">Batches</div>
                            <div className="card-value">
                              {invoice.batchNumber1 || "-"}
                              {invoice.batchNumber2
                                ? `, ${invoice.batchNumber2}`
                                : ""}
                              {invoice.batchNumber3
                                ? `, ${invoice.batchNumber3}`
                                : ""}
                            </div>
                          </div>

                          {/* Collapsible Content */}
                          <div
                            className={`card-extra ${
                              openCards[invoice.inv_no] ? "show" : ""
                            }`}
                          >
                            <div className="card-row">
                              <div className="card-label">Payment</div>
                              <div className="card-value">
                                ₹
                                {formatNumberWithCommas(
                                  invoice.trainerAskedPayment || 0,
                                )}
                              </div>
                            </div>

                            <div className="card-row">
                              <div className="card-label">Net Payable</div>
                              <div className="card-value">
                                ₹
                                {formatNumberWithCommas(
                                  invoice.netPayable ?? 0,
                                )}
                              </div>
                            </div>

                            <div className="card-row small">
                              <div className="card-label">Age</div>
                              <div className="card-value">
                                {getInvoiceAge(invoice.date)}
                              </div>
                            </div>

                            <div className="card-row status-row">
                              <div className="card-label">Status</div>
                              <div className="card-value">
                                <select
                                  value={invoice.status}
                                  onChange={(e) =>
                                    handleStatusChange(
                                      invoice.inv_no,
                                      e.target.value,
                                    )
                                  }
                                  className="card-status-select"
                                  style={{
                                    backgroundColor: getStatusColor(
                                      invoice.status || "Open",
                                    ),
                                    color: "white",
                                    fontWeight: "600",
                                  }}
                                >
                                  <option value="Approved">Approved</option>
                                  <option value="Hold">Hold</option>
                                  <option value="Open">Open</option>
                                  <option value="Receipt Sent">
                                    Receipt Sent
                                  </option>
                                  <option value="Processing">Processing</option>
                                  <option value="Payment Sent">
                                    Payment Sent
                                  </option>
                                  <option value="Submitted">Submitted</option>
                                </select>
                              </div>
                            </div>

                            <div className="card-actions">
                              <Button
                                onClick={() => handleDelete(invoice.inv_no)}
                                color="red"
                                size="xs"
                                style={{ padding: "6px 8px", fontSize: "12px" }}
                              >
                                Delete
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* To Show the Duplicate Entries in Table  */}
              {/* <div style={{ marginTop: "20px" }}>
    <h3>Duplicate Entries</h3>
    {duplicates.length > 0 ? (
      <ul>
        {duplicates.map((duplicate) => (
          <li key={duplicate.batchNumber}>
            <strong>Batch Number:</strong> {duplicate.batchNumber} &rarr;{" "}
            <strong>Invoice Numbers:</strong> {duplicate.ids.join(", ")}
          </li>
        ))}
      </ul>
    ) : (
      <p>No duplicate entries found.</p>
    )}
  </div>  */}
              {/* Modal */}

              {/* Table for displaying duplicates */}
              {/* Modal for duplicates */}
              {isDuplicateModalOpen && (
                <div
                  className="dup-table"
                  style={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    padding: "20px",
                    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                    zIndex: 1000,
                  }}
                >
                  {/* <h2>Duplicate Invoices</h2>
              <button onClick={closeDuplicateModal} style={{ float: "right", marginBottom: "10px" }}>
                Close
              </button> */}

                  {error && <p style={{ color: "red" }}>{error}</p>}

                  {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
  <thead>
    <tr className="dup-head" style={{ backgroundColor: "#f2f2f2" }}>
      <th style={{ border: "1px solid #ddd", padding: "8px" }}>Batch Number</th>
      <th style={{ border: "1px solid #ddd", padding: "8px" }}>Invoice Numbers</th>
    </tr>
  </thead>
  <tbody>
    {duplicatess.map((duplicate, index) => (
      <tr key={index}>
        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
          {duplicate.batchNumber1} {duplicate.batchNumber2 && `, ${duplicate.batchNumber2}`} {duplicate.batchNumber3 && `, ${duplicate.batchNumber3}`}
        </td>
        <td style={{ border: "1px solid #ddd", padding: "8px" }}>
          <span
            style={{
              color: "blue",
              cursor: "pointer",
              marginRight: "10px",
              textDecoration: "underline",
            }}
            onClick={() => handleDuplicateInvoiceClick(duplicate.inv_no)}
          >
            {duplicate.inv_no}
          </span>
        </td>
      </tr>
    ))}
  </tbody>
</table> */}
                </div>
              )}

              {/* This Modal is for When We Select Processing in status this Modal is Open */}
              <Modal
                opened={showProcessingModal}
                onClose={() => setShowProcessingModal(false)}
                title="Invoice Processing"
                size="md"
                className="compact-modal"
              >
                <TextInput
                  label="Invoice Number"
                  value={selectedInvoiceForProcessing?.inv_no || ""}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="Trainer Name"
                  value={selectedInvoiceForProcessing?.trainerName || ""}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="Batch Number 1"
                  value={selectedInvoiceForProcessing?.batchNumber1 || ""}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="Batch Number 2"
                  value={selectedInvoiceForProcessing?.batchNumber2 || ""}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="Batch Number 3"
                  value={selectedInvoiceForProcessing?.batchNumber3 || ""}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />

                <TextInput
                  label="Account Details"
                  value={
                    selectedInvoiceForProcessing?.instructor_bank_account || ""
                  }
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="UPI Details"
                  value={selectedInvoiceForProcessing?.instructor_upi_id || ""}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="PAN Number"
                  value={selectedInvoiceForProcessing?.instructor_pan || ""}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="Net Payable"
                  value={`₹${selectedInvoiceForProcessing?.netPayable || 0}`}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />
                <TextInput
                  label="TDS Amount"
                  value={`₹${selectedInvoiceForProcessing?.tds || 0}`}
                  readOnly
                  style={{ marginBottom: "10px" }}
                />

                <Group justify="flex-end" style={{ marginTop: "1rem" }}>
                  <CopyButton
                    value={`
Invoice Number:${selectedInvoiceForProcessing?.inv_no || ""}                     
PAN:  ${selectedInvoiceForProcessing?.instructor_pan || "N/A"}
Trainer Name:  ${selectedInvoiceForProcessing?.trainerName || ""}
Account Details: ${selectedInvoiceForProcessing?.instructor_bank_account || ""}
UPI Details:${selectedInvoiceForProcessing?.instructor_upi_id || ""}
Net Payable:  ₹${selectedInvoiceForProcessing?.netPayable || 0}
Amount: Confirm
${selectedInvoiceForProcessing?.tds ? "10% TDS Deduction" : ""}
TDS Amount:  ₹${selectedInvoiceForProcessing?.tds || 0}

Course Name:  ${selectedInvoiceForProcessing?.courseName || "N/A"}
Batch Number 1: ${selectedInvoiceForProcessing?.batchNumber1 || "N/A"}
Batch Number 2: ${selectedInvoiceForProcessing?.batchNumber2 || "N/A"}
Batch Number 3: ${selectedInvoiceForProcessing?.batchNumber3 || "N/A"}
    `.trim()}
                  >
                    {({ copied, copy }) => (
                      <Button onClick={copy} color={copied ? "green" : "gray"}>
                        {copied ? "Copied" : "Copy Text"}
                      </Button>
                    )}
                  </CopyButton>
                </Group>
              </Modal>

              {/* // this is the Modal for Upload Screenshot  */}
              {showPaymentSentModal && selectedInvoiceForPaymentSent && (
                <Modal
                  opened={showPaymentSentModal}
                  onClose={() => setShowPaymentSentModal(false)}
                  title={`Upload Screenshots for Invoice #${selectedInvoiceForPaymentSent.inv_no}`}
                  size="md"
                  className="compact-modal"
                >
                  {/* File Input Section */}
                  <div
                    style={{ marginBottom: "20px", width: "calc(50% - 10px)" }}
                  >
                    <input
                      type="file"
                      accept="image/*"
                      multiple // Allow multiple file selection
                      onChange={(e) => {
                        const files = Array.from(e.target.files || []);
                        setSelectedFile(files); // Set selected files
                        const previews = files.map((file) =>
                          URL.createObjectURL(file),
                        ); // Generate previews
                        setFilePreviews(previews); // Set previews to state
                      }}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>

                  <div
                    style={{ marginBottom: "20px", width: "calc(50% - 10px)" }}
                  >
                    <label>
                      Issue Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="date"
                      value={issueDate}
                      onChange={(e) => setIssueDate(e.target.value)}
                      required
                    />
                  </div>

                  {/* Preview Section */}
                  <div style={{ marginBottom: "20px" }}>
                    {filePreviews.length > 0 ? (
                      <Group align="center">
                        {filePreviews.map((preview, index) => (
                          <div
                            key={index}
                            className="preview-item"
                            style={{
                              position: "relative",
                              width: "160px", // smaller preview to avoid overflow
                              height: "auto",
                              margin: "10px",
                            }}
                          >
                            {/* Image Preview */}
                            <img
                              src={preview}
                              alt={`Preview ${index + 1}`}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "2px solid #ccc",
                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              }}
                            />
                            {/* Remove Button */}
                            <Button
                              size="xs"
                              color="red"
                              style={{
                                position: "absolute",
                                top: "8px",
                                right: "8px",
                                borderRadius: "50%",
                              }}
                              onClick={() => {
                                const updatedPreviews = filePreviews.filter(
                                  (_, i) => i !== index,
                                );
                                const updatedFiles = selectedFile.filter(
                                  (_, i) => i !== index,
                                );
                                setFilePreviews(updatedPreviews); // Update previews
                                setSelectedFile(updatedFiles); // Update files
                              }}
                            >
                              ✕
                            </Button>
                          </div>
                        ))}
                      </Group>
                    ) : (
                      <Text>No previews available. Please upload images.</Text>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <Group justify="flex-end" style={{ marginTop: "1rem" }}>
                    <Button
                      color="red"
                      onClick={() => {
                        setShowPaymentSentModal(false);
                        setSelectedFile([]);
                        setFilePreviews([]);
                      }}
                      disabled={isUploading}
                    >
                      Cancel
                    </Button>

                    <div style={{ marginBottom: "10px" }}>
                      <Checkbox
                        label="Send Remittance"
                        checked={sendWithRemittance}
                        onChange={(event) => {
                          setSendWithRemittance(event.currentTarget.checked);

                          // Ensure correct invoice is selected
                          const invoice = currentRows.find(
                            (invoice) =>
                              invoice.inv_no ===
                              selectedInvoiceForPaymentSent?.inv_no,
                          );

                          if (invoice) {
                            setSelectedInvoiceForPaymentSent(invoice);
                          }
                        }}
                      />
                    </div>
                    <Button
                      color="green"
                      onClick={async () => {
                        if (selectedInvoiceForPaymentSent) {
                          setIsUploading(true);

                          try {
                            const formData = new FormData();
                            formData.append(
                              "inv_no",
                              selectedInvoiceForPaymentSent.inv_no,
                            );

                            if (selectedFile.length > 0) {
                              selectedFile.forEach((file) =>
                                formData.append("files", file),
                              );
                            } else {
                              formData.append("screenshotUrls", ""); // Empty string if no files
                            }
                            const uploadResponse =
                              await ApiService.getInstance().post(
                                "/bucket/upload-multiple",
                                formData,
                              );

                            // **Get newly uploaded image URLs**
                            const newImageUrls =
                              uploadResponse.data.imageUrls || [];

                            // **Update the state so that images appear instantly**
                            setScreenshotUrl((prevUrls) => [
                              ...prevUrls,
                              ...newImageUrls,
                            ]);
                            setScreenshotCache((prevCache) => ({
                              ...prevCache,
                              [selectedInvoiceForPaymentSent.inv_no]: [
                                ...(prevCache[
                                  selectedInvoiceForPaymentSent.inv_no
                                ] || []),
                                ...newImageUrls,
                              ],
                            }));

                            // Invoice status update
                            setInvoices((prevInvoices) =>
                              prevInvoices.map((invoice) =>
                                invoice.inv_no ===
                                selectedInvoiceForPaymentSent.inv_no
                                  ? { ...invoice, status: "Payment Sent" }
                                  : invoice,
                              ),
                            );

                            await fetchUpdateInvoiceStatus(
                              selectedInvoiceForPaymentSent.inv_no,
                              "Payment Sent",
                              issueDate, // persist selected issue date to DB
                            );

                            showNotification({
                              title: "Success",
                              message: `Invoice #${selectedInvoiceForPaymentSent.inv_no} marked as Payment Sent.`,
                              color: "green",
                            });

                            setShowPaymentSentModal(false);
                            setSelectedFile([]);
                            setFilePreviews([]);

                            //  Send email if checkbox is checked
                            if (sendWithRemittance) {
                              const pdfBase64 = generateRemittancePDF();
                              await ApiService.getInstance().post("/bucket", {
                                inv_no: selectedInvoiceForPaymentSent?.inv_no,
                                email:
                                  selectedInvoiceForPaymentSent?.instructor_email,
                                pdfData: pdfBase64,
                                screenshotUrls: newImageUrls,
                                name: selectedInvoiceForPaymentSent?.trainerName,
                              });

                              alert(
                                `Remittance email sent successfully to ${selectedInvoiceForPaymentSent.instructor_email}`,
                              );
                            }
                          } catch (error) {
                            console.error("Error processing request:", error);
                            showNotification({
                              title: "Error",
                              message:
                                "Failed to update status. Please try again.",
                              color: "red",
                            });
                          } finally {
                            setIsUploading(false);
                          }
                        } else {
                          alert("No invoice selected.");
                        }
                      }}
                      loading={isUploading}
                      disabled={isUploading}
                    >
                      Submit
                    </Button>
                  </Group>
                </Modal>
              )}

              <Modal
                opened={isModalOpen}
                onClose={() => {
                  closeModal(); // Close the modal
                  setIsEditing(false); // Disable edit mode when modal is closed
                }}
                size="lg"
                className="compact-modal"
                // scrollAreaComponent={ScrollArea.Autosize}
                title={
                  <span style={{ fontWeight: "bold" }}>
                    Edit Invoice - {selectedInvoice?.inv_no}
                  </span>
                }
                yOffset="1vh"
                transitionProps={{
                  transition: "fade",
                  duration: 600,
                  timingFunction: "linear",
                }}
              >
                <Button onClick={() => setOpened(true)}>
                  Add New Instructor
                </Button>
                <Modal
                  opened={opened}
                  onClose={() => setOpened(false)}
                  title="Add New Instructor"
                  size="md"
                  className="compact-modal"
                >
                  <LoadingOverlay visible={loading} />

                  <form
                    onSubmit={form.onSubmit((values) =>
                      handleCreateInstructor(values),
                    )}
                  >
                    <TextInput
                      label="Name"
                      placeholder="Enter instructor's name"
                      {...form.getInputProps("name")}
                      required
                    />

                    <TextInput
                      label="Email"
                      placeholder="Enter instructor's email"
                      {...form.getInputProps("email")}
                      required
                    />

                    <NumberInput
                      label="SNO"
                      value={form.values.sno}
                      readOnly
                      disabled
                    />

                    <TextInput
                      label="Contact"
                      placeholder="Enter contact number"
                      {...form.getInputProps("contact")}
                    />

                    <Textarea
                      label="Tags"
                      placeholder="Enter tags (comma-separated)"
                      {...form.getInputProps("tags")}
                    />

                    <TextInput
                      label="UPI ID"
                      placeholder="Enter UPI ID"
                      {...form.getInputProps("instructor_upi_id")}
                    />

                    <TextInput
                      label="PAN"
                      placeholder="Enter PAN number"
                      {...form.getInputProps("instructor_pan")}
                    />

                    <Textarea
                      label="Bank Account"
                      placeholder="Enter bank account number"
                      {...form.getInputProps("instructor_bank_account")}
                    />

                    <Group justify="right" mt="md">
                      <Button type="submit" color="blue" loading={loading}>
                        Submit
                      </Button>
                      <Button color="gray" onClick={() => setOpened(false)}>
                        Cancel
                      </Button>
                    </Group>
                  </form>
                </Modal>

                {selectedInvoice && (
                  <div>
                    {/* Invoice Info Section */}
                    {/* Sticky Header Section */}

                    <div
                      style={{
                        position: "sticky",
                        top: 0,
                        background: "white", // Ensure background covers content below
                        zIndex: 1000, // Keep it above other content
                        padding: "10px 0",
                        borderBottom: "1px solid #ddd", // Optional separator
                      }}
                    >
                      <h2
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        Invoice Info
                        <a
                          href="#"
                          onClick={handleEditClick} // Edit functionality
                          style={{
                            fontSize: "14px",
                            color: "blue",
                            textDecoration: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            cursor: "pointer",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            background: "#f3f3f3",
                            transition: "background 0.3s",
                          }}
                        >
                          <i
                            className={`fas ${
                              isEditing ? "fa-lock" : "fa-edit"
                            }`}
                            style={{ marginRight: "5px" }}
                          ></i>
                          {isEditing ? "Disable Edit" : "Edit"}
                        </a>
                      </h2>
                    </div>

                    {/* Alert if user tries to edit without enabling edit mode */}
                    {/* {showAlert && (
                  <Alert color="red" title="Edit Mode Not Enabled">
                    You must enable the edit mode before making changes to the fields.
                  </Alert>
                )} */}
                    <Flex direction="row" gap="1rem">
                      <TextInput
                        label="Invoice No"
                        value={selectedInvoice.inv_no}
                        readOnly
                        style={{ flex: 1 }}
                      />
                      <TextInput
                        label="Date"
                        type="date"
                        value={selectedInvoice.date || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev ? { ...prev, date: e.target.value } : null,
                          )
                        }
                        readOnly={!isEditing} // Enable or disable based on editing mode
                        style={{ flex: 1 }}
                      />
                      <TextInput
                        label="Course Name"
                        value={selectedInvoice.courseName || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? { ...prev, courseName: e.target.value }
                              : null,
                          )
                        }
                        readOnly={!isEditing} // Enable or disable based on editing mode
                        style={{ flex: 1 }}
                      />
                    </Flex>

                    <Divider my="lg" />
                    {/* Student Info Section in Modal */}
                    <h2>Student Info</h2>

                    {/* Number of Students */}
                    <NumberInput
                      label="Number of Students"
                      value={selectedInvoice.numberOfStudents || 0}
                      onChange={(value) =>
                        setSelectedInvoice((prev) =>
                          prev
                            ? { ...prev, numberOfStudents: value as number }
                            : null,
                        )
                      }
                      readOnly={!isEditing}
                    />

                    <Flex
                      direction="row"
                      wrap="wrap"
                      align="center"
                      gap="md"
                      mt="1rem"
                    >
                      {(selectedInvoice?.studentDetails || []).map(
                        (student, index) => (
                          <Group key={index} mt="sm" align="center" grow>
                            {/* Name of Student */}
                            <TextInput
                              label="Name of Student"
                              placeholder={`Student ${index + 1}`}
                              value={student.name}
                              onChange={(e) =>
                                handleStudentDetailChange(
                                  index,
                                  "name",
                                  e.target.value,
                                )
                              }
                              readOnly={!isEditing}
                            />

                            {/* No. of Classes */}
                            <TextInput
                              label="No. of Classes"
                              placeholder="Enter number of classes"
                              value={student.numOfClasses}
                              onChange={(e) =>
                                handleStudentDetailChange(
                                  index,
                                  "numOfClasses",
                                  e.target.value,
                                )
                              }
                              readOnly={!isEditing}
                            />

                            {/* Remove Student */}
                            {isEditing && (
                              <Button
                                color="red"
                                onClick={() => removeStudentField(index)}
                              >
                                -
                              </Button>
                            )}
                          </Group>
                        ),
                      )}
                    </Flex>

                    {/* Add Student Button */}
                    {isEditing && (
                      <Button mt="sm" onClick={addStudentField}>
                        + Add Student
                      </Button>
                    )}

                    <Divider my="lg" />

                    {/* Batch Info Section */}
                    <h2>Batch Info</h2>
                    <div className="box batch-info">
                      <Flex direction="row" wrap="wrap" align="center" gap="md">
                        <Select
                          label="Batch 1"
                          value={
                            selectedInvoice?.batchNumber1?.toString() || ""
                          }
                          onChange={handleModalBatchSelection}
                          data={batchOptions}
                          searchable
                          placeholder="Select Batch 1"
                          style={{ flex: 1 }}
                          // ADD THESE PROPS TO FIX THE DESELECTION ISSUE:
                          clearable={false} // Prevents the clear button
                          allowDeselect={false} // Prevents deselecting when clicking same option
                          checkIconPosition="right" // Optional: moves check icon to right
                        />

                        <TextInput
                          label="Batch 2"
                          value={
                            selectedInvoice?.batchNumber2?.toString() || ""
                          }
                          readOnly
                          style={{ flex: 1 }}
                        />

                        <TextInput
                          label="Batch 3"
                          value={
                            selectedInvoice?.batchNumber3?.toString() || ""
                          }
                          readOnly
                          style={{ flex: 1 }}
                        />
                      </Flex>
                    </div>

                    {/* Row 2: Course Name, No. of Trainer Leaves, No. of Classes */}
                    <Flex
                      direction="row"
                      gap="1rem"
                      wrap="wrap"
                      style={{ marginTop: "1rem" }}
                    >
                      <TextInput
                        label="Course Name"
                        value={selectedInvoice.courseName || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? { ...prev, courseName: e.target.value }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                      <TextInput
                        label="No. of Trainer Leaves"
                        value={selectedInvoice.leaves || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? { ...prev, leaves: Number(e.target.value) }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                  <TextInput
  label="No. of Hours"
  value={formatDecimalHoursToTime(selectedInvoice?.classes) || ""}
  onChange={(e) =>
    setSelectedInvoice((prev) =>
      prev
        ? { ...prev, classes: Number(e.target.value) }
        : null
    )
  }
  readOnly={!isEditing}
  style={{ flex: 1 }}
/>
                    </Flex>

                    {/* Row 3: Classes As Per MOU, Cost As Per MOU, Trainer Asked for Payment */}
                    <Flex
                      direction="row"
                      gap="1rem"
                      wrap="wrap"
                      style={{ marginTop: "1rem" }}
                    >
                      <TextInput
                        label="Classes As Per MOU"
                        value={selectedInvoice.numClassesAsMOU || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  numClassesAsMOU: Number(e.target.value),
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                      <TextInput
                        label="MOU Amount (Per Student)"
                        value={formatNumberWithCommas(
                          selectedInvoice.costAsPerMOU || "",
                        )} // Format value
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  costAsPerMOU: parseNumberFromFormattedString(
                                    e.target.value,
                                  ), // Remove commas and store raw number
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />

                      <TextInput
                        label="Trainer Amount (As Per Invoice)"
                        value={formatNumberWithCommas(
                          selectedInvoice.trainerAskedPayment || "",
                        )} // Format value
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  trainerAskedPayment:
                                    parseNumberFromFormattedString(
                                      e.target.value,
                                    ), // Remove commas and store raw number
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                    </Flex>

                    <Divider my="lg" />

                    {/* Trainer Info Section */}
                    <h2>Trainer Info</h2>
                    <Flex direction="row" gap="1rem">
                      <Select
                        label="Trainer Email ID"
                        id="email"
                        name="instructor_email"
                        data={instructors}
                        value={selectedInvoice.instructor_email}
                        searchable
                        required={true}
                        onChange={(val) =>
                          handleModalChange("instructor_email", val)
                        }
                        placeholder="Select Email"
                        nothingFoundMessage="Nothing found..."
                        filter={handleInstructorSearch}
                        style={{ flex: 1 }}
                      />
                      <TextInput
                        label="Trainer Name"
                        value={selectedInvoice.trainerName || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? { ...prev, trainerName: e.target.value }
                              : null,
                          )
                        }
                        onClick={handleFieldClick}
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                      {/* <TextInput
    label="Trainer Email"
    value={selectedInvoice.instructor_email || ""}
    onChange={(e) =>
      setSelectedInvoice((prev) =>
        prev ? { ...prev, instructor_email: e.target.value } : null
      )
    }
    readOnly={!isEditing}
    style={{ flex: 1 }}
  /> */}
                      <TextInput
                        label="Trainer Phone"
                        value={selectedInvoice.instructor_contact || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? { ...prev, instructor_contact: e.target.value }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                    </Flex>

                    <div style={{ display: "flex", gap: "1rem" }}></div>

                    <Flex direction="row" gap="1rem" mt="1rem">
                      <Textarea
                        label="Trainer Bank Details"
                        value={selectedInvoice.instructor_bank_account || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  instructor_bank_account: e.target.value,
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        autosize
                        minRows={3} // Minimum rows (starting size)
                        maxRows={8} // Maximum rows before scrolling
                        style={{ flex: 1 }}
                      />

                      <TextInput
                        label="Trainer UPI ID"
                        value={selectedInvoice.instructor_upi_id || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? { ...prev, instructor_upi_id: e.target.value }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                      <TextInput
                        label="Trainer PAN"
                        value={selectedInvoice.instructor_pan || ""}
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  instructor_pan: e.target.value.toUpperCase(),
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                    </Flex>
                    <Remark
                      remark={selectedInvoice.remark || ""}
                      onRemarkChange={handleRemarkChange}
                      isEditing={isEditing}
                    />
                    <Textarea
                      label="Internal Description"
                      description="Visible to the internal team only"
                      placeholder="Add internal pointers for this invoice"
                      value={selectedInvoice.internalDescription || ""}
                      onChange={(e) =>
                        setSelectedInvoice((prev) =>
                          prev
                            ? { ...prev, internalDescription: e.target.value }
                            : null,
                        )
                      }
                      readOnly={!isEditing}
                      minRows={3}
                      resize="vertical"
                      mb="md"
                    />

                    {/* Duplicate Information Table According to Batch Number */}
                    {/* Duplicate Information Table According to Batch Number */}
                    {/* Duplicate Information Table According to Batch Number */}
                    <Divider my="lg" />
                    <h2>Duplicate Info</h2>
                    {loading ? (
                      <p>Loading duplicate information...</p>
                    ) : error ? (
                      <p style={{ color: "red" }}>{error}</p>
                    ) : duplicatess.length > 1 ? (
                      <div className="dup-section">
                        {/* This container makes ONLY the table scrollable */}
                        <div
                          style={{
                            width: "100%",
                            overflowX: "auto", // Adds horizontal scrollbar when needed
                            marginTop: "1rem",
                            border: "1px solid #e0e0e0",
                            borderRadius: "8px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          }}
                        >
                          <table
                            style={{
                              width: "100%",
                              minWidth: "1200px", // Ensures table is wide enough to scroll
                              borderCollapse: "collapse",
                              backgroundColor: "#fff",
                            }}
                          >
                            <thead>
                              <tr
                                className="dup-section-header"
                                style={{
                                  backgroundColor: "#f8f9fa",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 10,
                                }}
                              >
                                {/* All your <th> headers go here... */}
                                <th style={{ minWidth: "120px" }}>
                                  Invoice Number
                                </th>
                                <th style={{ minWidth: "150px" }}>
                                  Trainer Name
                                </th>
                                <th style={{ minWidth: "180px" }}>
                                  Course Name
                                </th>
                                <th style={{ minWidth: "100px" }}>Date</th>
                                <th style={{ minWidth: "90px" }}>Batch 1</th>
                                <th style={{ minWidth: "90px" }}>Batch 2</th>
                                <th style={{ minWidth: "90px" }}>Batch 3</th>
                                <th style={{ minWidth: "140px" }}>Payment %</th>
                                <th style={{ minWidth: "130px" }}>
                                  No. of Students
                                </th>
                                <th style={{ minWidth: "90px" }}>Classes</th>
                                <th style={{ minWidth: "110px" }}>
                                  TDS Amount
                                </th>
                                <th style={{ minWidth: "120px" }}>
                                  Net Payable
                                </th>
                                <th style={{ minWidth: "100px" }}>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {duplicatess
                                .filter(
                                  (dup) =>
                                    dup.inv_no !== selectedInvoice?.inv_no,
                                )
                                .map((dup, index) => {
                                  // ... your mapping logic for table rows ...
                                  const uniqueKey = `${dup.inv_no}-${dup.batchNumber1}-${dup.batchNumber2}-${dup.batchNumber3}`;
                                  const isEvenRow = index % 2 === 0;
                                  return (
                                    <tr
                                      key={uniqueKey}
                                      style={{
                                        backgroundColor: isEvenRow
                                          ? "#ffffff"
                                          : "#f8f9fa",
                                      }}
                                    >
                                      {/* All your <td> cells go here... */}
                                      <td>{dup.inv_no || "N/A"}</td>
                                      <td>{dup.trainerName || "N/A"}</td>
                                      <td>{dup.courseName || "N/A"}</td>
                                      <td>{dup.date || "N/A"}</td>
                                      <td>{dup.batchNumber1 || "N/A"}</td>
                                      <td>{dup.batchNumber2 || "N/A"}</td>
                                      <td>{dup.batchNumber3 || "N/A"}</td>
                                      <td>{dup.paymentPercentage || "N/A"}</td>
                                      <td>{dup.numberOfStudents || "N/A"}</td>
                                      <td>{dup.classes || "N/A"}</td>
                                      <td>{dup.tds || "N/A"}</td>
                                      <td>{dup.netPayable || "N/A"}</td>
                                      <td>{dup.status || "N/A"}</td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                        {/* Optional: Scroll Hint */}
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6c757d",
                            marginTop: "8px",
                            fontStyle: "italic",
                            textAlign: "center",
                          }}
                        >
                          ← Scroll horizontally to view all columns →
                        </p>
                      </div>
                    ) : (
                      <p>No duplicates found for this invoice.</p>
                    )}
                    <Divider my="lg" />
                    {/* <Button onClick={getDuplicates} style={{ marginTop: "10px" }}>
  Refresh Duplicates
</Button> */}

                    {/* Payment Info Section */}
                    <h2>Payment Info</h2>
                    <Flex direction="row" gap="1rem">
                      <TextInput
                        label="Cost As Per MOU"
                        value={formatNumberWithCommas(
                          selectedInvoice.costAsPerMOU || "",
                        )} // Format value
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  costAsPerMOU: parseNumberFromFormattedString(
                                    e.target.value,
                                  ), // Remove commas and store raw number
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                      <TextInput
                        label="Trainer Asked Payment"
                        value={formatNumberWithCommas(
                          selectedInvoice.trainerAskedPayment || "",
                        )} // Format value
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  trainerAskedPayment:
                                    parseNumberFromFormattedString(
                                      e.target.value,
                                    ), // Remove commas and store raw number
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />

                      <TextInput
                        label="Net Payable"
                        value={formatNumberWithCommas(
                          selectedInvoice.netPayable || "",
                        )} // Format value
                        onChange={(e) =>
                          setSelectedInvoice((prev) =>
                            prev
                              ? {
                                  ...prev,
                                  netPayable: parseNumberFromFormattedString(
                                    e.target.value,
                                  ), // Remove commas and store raw number
                                }
                              : null,
                          )
                        }
                        readOnly={!isEditing}
                        style={{ flex: 1 }}
                      />
                    </Flex>

                    <Divider my="lg" />

                    {/* Calculation Section */}
                    <div className="box calculation-info">
                      <h2>Calculation</h2>

                      {/* First Row: Pro-Rata, Deduction, Net Payable */}
                      <Flex direction="row" wrap="wrap" align="center" gap="md">
                        {/* <Checkbox
                      label="Pro-Rata"
                      checked={selectedInvoice.prorata || false}
                      onChange={(e) =>
                        setSelectedInvoice((prev) =>
                          prev ? { ...prev, prorata: e.currentTarget.checked } : null
                        )
                      }
                      readOnly={!isEditing}
                      style={{ flex: 1 }}
                    /> */}
                        {/* Checkbox for TDS */}
                        <Checkbox
                          label="TDS Applicable"
                          checked={selectedInvoice?.tdsStatus === "Yes"}
                          onChange={(e) => {
                            if (!isEditing) return; // Prevent changes if not in editing mode
                            const isChecked = e.currentTarget.checked;

                            setSelectedInvoice((prev) =>
                              prev
                                ? {
                                    ...prev,
                                    tdsStatus: isChecked ? "Yes" : "No",
                                  }
                                : null,
                            );

                            setFormData((prev) => ({
                              ...prev,
                              tdsStatus: isChecked ? "Yes" : "No",
                            }));
                          }}
                          readOnly={!isEditing} // Makes it non-interactive when not in edit mode
                        />

                        {selectedInvoice?.tdsStatus === "Yes" && (
                          <TextInput
                            label="TDS Amount"
                            value={
                              typeof selectedInvoice?.tds === "number"
                                ? `₹${selectedInvoice.tds.toFixed(2)}`
                                : "" // Default to empty string if tds is invalid
                            }
                            readOnly={!isEditing} // Prevent editing unless in edit mode
                          />
                        )}

                        <TextInput
                          label="Approved By"
                          value={selectedInvoice.approvedBy || ""}
                          onChange={(e) =>
                            setSelectedInvoice((prev) =>
                              prev
                                ? { ...prev, approvedBy: e.target.value }
                                : null,
                            )
                          }
                          readOnly={!isEditing}
                          style={{ flex: 1 }}
                        />
                      </Flex>

                      {/* Second Row: Custom Calculation, Deduction, Payment Percentage */}
                      <Flex
                        direction="row"
                        wrap="wrap"
                        align="center"
                        gap="md"
                        mt="md"
                      >
                        {/*  Deduction Amount */}
                        <NumberInput
                          label="Deduction"
                          value={selectedInvoice?.leavesAmountDeducted || 0}
                          onChange={(value) =>
                            setSelectedInvoice((prev) =>
                              prev
                                ? {
                                    ...prev,
                                    leavesAmountDeducted: Number(value) || 0,
                                  }
                                : null,
                            )
                          }
                          readOnly={!isEditing}
                          style={{ flex: 1 }}
                        />

                        {/*  Payment Type (Radio Button) */}
                        <Flex
                          direction="column"
                          style={{ flex: 1, minWidth: "200px" }}
                        >
                          <label
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            Payment Type
                          </label>
                          <Radio.Group
                            value={selectedInvoice?.paymentType || ""}
                            onChange={(value) =>
                              setSelectedInvoice((prev) =>
                                prev
                                  ? {
                                      ...prev,
                                      paymentType: value,
                                      paymentPercentage:
                                        value === "full"
                                          ? 100
                                          : value === "prorata"
                                            ? 0
                                            : prev.paymentPercentage,
                                    }
                                  : null,
                              )
                            }
                          >
                            <Flex direction="column" gap="xs">
                              <Radio value="first" label="First" />
                              <Radio value="last" label="Last" />
                              <Radio value="prorata" label="Prorata" />
                              <Radio value="full" label="Full" />
                            </Flex>
                          </Radio.Group>
                        </Flex>
                        {/*  Payment Percentage (Slider) */}
                        <Flex direction="column" style={{ minWidth: "200px" }}>
                          <label
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            Payment Percentage
                          </label>
                          <Slider
                            value={selectedInvoice?.paymentPercentage || 0}
                            onChange={(value) =>
                              setSelectedInvoice((prev) =>
                                prev
                                  ? {
                                      ...prev,
                                      paymentPercentage: Number(value) || 0,
                                    }
                                  : null,
                              )
                            }
                            min={0}
                            max={100}
                            step={25}
                            marks={[
                              { value: 0, label: "0%" },
                              { value: 25, label: "25%" },
                              { value: 50, label: "50%" },
                              { value: 75, label: "75%" },
                              { value: 100, label: "100%" },
                            ]}
                            disabled={
                              selectedInvoice?.paymentType === "prorata"
                            } //  Disable Slider if "prorata"
                            styles={{
                              track: {
                                height: "8px",
                                background:
                                  "linear-gradient(90deg, #ff9a9e, #fad0c4)",
                              },
                              thumb: {
                                width: "18px",
                                height: "18px",
                                backgroundColor: "white",
                                border: "3px solid #ff6f61",
                                borderRadius: "50%",
                              },
                              markLabel: {
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#444",
                              },
                            }}
                          />
                        </Flex>
                      </Flex>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h3>Payment Screenshot</h3>
                      {/* Add Screenshot Button */}
                      <Button
                        color="blue"
                        onClick={() => {
                          setShowPaymentSentModal(true);
                          setSelectedInvoiceForPaymentSent(selectedInvoice);
                        }}
                      >
                        Add Screenshot
                      </Button>
                      {screenshotLoading ? (
                        <p>Loading screenshot...</p>
                      ) : screenshotError ? (
                        <p style={{ color: "red" }}>{screenshotError}</p>
                      ) : screenshotUrl.length > 0 ? (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "16px",
                          }}
                        >
                          {screenshotUrl.map((url, index) => (
                            <div
                              key={index}
                              style={{ position: "relative", width: "150px" }}
                            >
                              <img
                                src={url}
                                alt={`Screenshot ${index + 1}`}
                                style={{
                                  width: "100%",
                                  height: "150px",
                                  objectFit: "cover",
                                  border: "1px solid #ccc",
                                  borderRadius: "8px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handlePreviewScreenshot(url)} // Open the modal for preview
                              />

                              {/* Delete Button (Cross Icon) */}
                              <button
                                style={{
                                  position: "absolute",
                                  top: "1px",
                                  right: "4px",
                                  background: "red",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "24px",
                                  height: "24px",
                                  cursor: "pointer",
                                }}
                                onClick={() => openConfirmDelete(url)} // Open confirmation dialog
                              >
                                ✕
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p>No screenshot available for this invoice.</p>
                      )}

                      {/* Preview Modal */}
                      {previewImage && (
                        <div
                          style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            background: "white",
                            padding: "20px",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            zIndex: 1000,
                          }}
                        >
                          <img
                            src={previewImage}
                            alt="Preview"
                            style={{
                              width: "100%",
                              maxHeight: "80vh",
                              objectFit: "contain",
                              borderRadius: "8px",
                            }}
                          />
                          <button
                            style={{
                              marginTop: "10px",
                              padding: "10px 20px",
                              background: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "4px",
                              cursor: "pointer",
                            }}
                            onClick={() => setPreviewImage(null)} // Close the modal
                          >
                            Close
                          </button>
                        </div>
                      )}

                      {/* Confirmation Dialog */}
                      {showConfirm && (
                        <div
                          style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            background: "white",
                            padding: "20px",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            zIndex: 1000,
                          }}
                        >
                          <p>
                            Are you sure you want to delete this screenshot?
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "20px",
                            }}
                          >
                            {/* Cancel Button */}
                            <button
                              style={{
                                padding: "10px 20px",
                                background: "lightgray",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={cancelDeleteScreenshot} // Close confirmation dialog
                            >
                              Cancel
                            </button>

                            {/* Confirm Delete Button */}
                            <button
                              style={{
                                padding: "10px 20px",
                                background: "red",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={confirmDeleteScreenshot} // Call delete function
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Overlay (for confirmation modal) */}
                      {showConfirm && (
                        <div
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(0, 0, 0, 0.4)",
                            zIndex: 999,
                          }}
                          onClick={cancelDeleteScreenshot} // Close confirmation dialog when clicking outside
                        />
                      )}
                    </div>

                    {/* Actions */}
                    <div
                      style={{
                        display: "flex",
                        marginTop: "1.5rem",
                        alignItems: "center",
                        gap: "15px",
                      }}
                    >
                      <Button
                        onClick={async () => {
                          if (selectedInvoice) {
                            try {
                              // Ensure selectedInvoice has all necessary data fields
                              const updatedInvoice = {
                                ...selectedInvoice,
                                studentNames:
                                  selectedInvoice.studentNames || [], // Ensure array exists
                                numOfClasses:
                                  selectedInvoice.numOfClasses || [], // Ensure array exists
                              };

                              // API call to update invoice
                              await ApiService.getInstance().put(
                                `/tc-invoice-details-trainers/${selectedInvoice.inv_no}`,
                                updatedInvoice,
                              );
                              alert("Invoice updated successfully!");
                              fetchInvoices(); // Refresh invoices list after update
                              closeModal(); // Close the modal after update
                            } catch (error) {
                              console.error("Error updating invoice:", error);
                              alert("Failed to update invoice.");
                            }
                          }
                        }}
                      >
                        Update Invoice
                      </Button>

                      {/* Delete Button */}
                      <Button
                        color="red"
                        onClick={() => handleDelete()} // No argument needed, uses selectedInvoice
                        style={{
                          backgroundColor: "red",
                          color: "white",
                        }}
                      >
                        Delete Invoice
                      </Button>

                      <Button
                        color="
                  red"
                        onClick={closeModal}
                      >
                        Cancel
                      </Button>
                      {/* <Button
  color="blue"
  onClick={() => setIsDuplicateModalOpen(true)}
>
  View Duplicates
</Button> */}
                      <Button
                        color="green"
                        onClick={() => handleCalculate("selectedInvoice")}
                      >
                        Calculate
                      </Button>
                      <Button
                        color="darkgreen"
                        onClick={async () => {
                          if (selectedInvoice) {
                            try {
                              // First, update the invoice
                              await ApiService.getInstance().put(
                                `/tc-invoice-details-trainers/${selectedInvoice.inv_no}`,
                                selectedInvoice,
                              );
                              alert("Invoice updated successfully!");

                              // Optimistically update the status to "Approve"
                              await handleStatusChange(
                                selectedInvoice.inv_no,
                                "Approved",
                              );

                              // Close the modal after successful approval
                              closeModal();
                            } catch (error) {
                              console.error(
                                "Error updating invoice or approving status:",
                                error,
                              );
                              alert(
                                "Failed to update invoice or approve status.",
                              );
                            }
                          }
                        }}
                      >
                        Approved
                      </Button>
                    </div>
                  </div>
                )}
              </Modal>
              <Modal
                opened={isSummaryOpen}
                onClose={() => setIsSummaryOpen(false)}
                title="Summary of Calculation"
                size="md"
                className="compact-modal"
                centered
              >
                <Table striped highlightOnHover>
                  <thead>
                    <tr>
                      <th>Status</th>
                      <th>Count</th>
                      <th>Net Payable (₹)</th>
                      <th>TDS (₹)</th>
                      <th>Total (₹)</th> {/* NEW COLUMN */}
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(statusSummary).map(([status, data]) => {
                      const total = data.netPayable + data.tds;
                      return (
                        <tr key={status}>
                          <td>{status}</td>
                          <td>{data.count}</td>
                          <td>{data.netPayable.toFixed(2)}</td>
                          <td>{data.tds.toFixed(2)}</td>
                          <td>{total.toFixed(2)}</td> {/* Total column */}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Modal>
            </>
          )}
        </Paper>
      </Container>
    </div>
  );
};

export default InvoicePage;
